import React from "react";
// import { browserHistory } from 'react-router';
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import {
	Layout,
	Drawer,
	Result,
	Button,
	message,
	notification,
	Modal,
	Row,
	Col,
	Spin,
	Skeleton,
	Card,
	Form,
	Alert,
	Input,
	InputNumber,
	Tag,
	Select,
	Tooltip,
	Badge,
	Empty,
	Typography,
} from 'antd';
import {
	CheckCircleOutlined,
	CloseCircleOutlined,
	WarningOutlined,
	ClockCircleOutlined,
	BankOutlined,
	EnvironmentOutlined,
	CheckCircleFilled,
	FileTextOutlined,
	SaveOutlined,
	NotificationOutlined,
	TeamOutlined,
	EditOutlined,
	EyeOutlined,
	EyeInvisibleOutlined,
	PlusOutlined,
	SyncOutlined,
	UserOutlined,
	CalendarOutlined,
	CodeOutlined,
	DesktopOutlined,
	InfoCircleOutlined,
	BellOutlined,
	ArrowLeftOutlined,
	CloudDownloadOutlined,
} from '@ant-design/icons';
import { enquireScreen, unenquireScreen } from 'enquire-js'
import buildInfo from '../buildInfo.json';
import 'antd/dist/antd.css';
import '../assets/style.css';
// import 'antd/dist/reset.css'; // untuk v5
// import '../assets/style.css';

import 'react-perfect-scrollbar/dist/css/styles.css';

import { connect } from 'react-redux';
import {
	setConfig,
	ajaxViewHandler,
	ajaxHandler
} from "../store/actions";
import { apiClient, getRefreshedAccessToken } from '../store/store';

// import axios from 'axios';
import Config from '../Config';
import Cookies from 'js-cookie';
import Sider from '../components/AdminSider';
import Header from '../components/AdminHeader';
import MobileBottomNav from '../components/MobileBottomNav';
import SkeletonTable from '../components/SkeletonTable';
import BoxVisualList from '../components/BoxVisualList';
import { registerDeviceSocket, unregisterDeviceSocket, clearLocalSession } from '../utils/sessionWS';
// import Footer from '../components/AdminFooter';

import { LayananRoute } from "../LayananRoute";

import Home from '../views/Home';
import Page404 from '../views/Page404';
import FormProfil from '../views/profil/FormProfil';
import Forbidden from '../views/Forbidden';
import DataPanduan from '../views/dokumentasi/DataPanduan';
import FormPanduan from '../views/dokumentasi/FormPanduan';

import DataNegara from '../views/negara/DataNegara';

import DataTipe from '../views/tipe/DataTipe';
import FormTipe from '../views/tipe/FormTipe';

import DataMerek from '../views/merek/DataMerek';
import DataKendaraan from '../views/kendaraan/DataKendaraan';
import FormKendaraan from '../views/kendaraan/FormKendaraan';
import FormTambahKendaraan from '../views/kendaraan/FormTambahKendaraan';

import DataJenisKendaraan from '../views/jenis_kendaraan/DataJenisKendaraan';
import FormJenisKendaraan from '../views/jenis_kendaraan/FormJenisKendaraan';

import DataBahanBakar from '../views/bahan_bakar/DataBahanBakar';

import DataWarna from '../views/warna/DataWarna';

import DataPekerjaan from '../views/pekerjaan/DataPekerjaan';
import FormPekerjaan from '../views/pekerjaan/FormPekerjaan';

import DataKepemilikan from '../views/kepemilikan/DataKepemilikan';
import FormKepemilikan from '../views/kepemilikan/FormKepemilikan';

import DataLayanan from '../views/layanan/DataLayanan';
import DataGudangNotice from '../views/gudangnotice/DataGudangNotice';
import FormLayanan from '../views/layanan/FormLayanan';

import DataDealer from '../views/dealer/DataDealer';
import FormDealer from '../views/dealer/FormDealer';

import DataPayment from '../views/payment/DataPayment';

import DataGolongan from '../views/golongan/DataGolongan';

import DataKabupaten from '../views/kabupaten/DataKabupaten';

import DataWarnaPlat from '../views/warna_plat/DataWarnaPlat';

import DataFungsi from '../views/fungsi/DataFungsi';

import FormPendaftaran from '../views/transaksi/FormPendaftaran';
import FormPendaftaranEri from '../views/transaksi/FormPendaftaranEri';

import FormPenetapanBiaya from '../views/transaksi/FormPenetapanBiaya';

import FormIwkbu from '../views/transaksi/FormIwkbu';
import FormBlokir from '../views/transaksi/FormBlokir';

import FormInformasiKendaraan from '../views/informasi/FormInformasiKendaraan';
import FormCariKendaraan from '../views/informasi/FormCariKendaraan';
import FormInformasiPenetapan from '../views/informasi/FormInformasiPenetapan';

// import InfoPajakKendaraan from '../views/informasi/InfoPajakKendaraan';

import DataNjkb from '../views/njkb/DataNjkb';
import FormNjkb from '../views/njkb/FormNjkb';

import DataSwdkllj from '../views/swdkllj/DataSwdkllj';
import FormSwdkllj from '../views/swdkllj/FormSwdkllj';

import DataAdmstnk from '../views/admstnk/DataAdmstnk';
import FormAdmstnk from '../views/admstnk/FormAdmstnk';

import DataAdmtnkb from '../views/admtnkb/DataAdmtnkb';
import FormAdmtnkb from '../views/admtnkb/FormAdmtnkb';

import DataDendaPkb from '../views/denda_pkb/DataDendaPkb';
import FormDendaPkb from '../views/denda_pkb/FormDendaPkb';

import DataDendaSwdkllj from '../views/denda_swdkllj/DataDendaSwdkllj';
import FormDendaSwdkllj from '../views/denda_swdkllj/FormDendaSwdkllj';
import SuratKeteranganFiskal from '../views/surat_fiskal/SuratKeteranganFiskal';

import FormPembayaran from '../views/transaksi/FormPembayaran';

import DataTandaTangan from '../views/tanda_tangan/DataTandaTangan';

import Laporan from '../views/laporan/Laporan';

import BbnkbDanPkb from '../views/laporan/BbnkbDanPkb';
import RekapitulasiPenerimaan from '../views/laporan/RekapitulasiPenerimaan';
import LapNotice from '../views/laporan/LapNotice';
import LapNoticeRusak from '../views/laporan/LapNoticeRusak';
import LapPenggunaanNoticeRusak from '../views/laporan/LapPenggunaanNoticeRusak';
import LapOverlapNotice from '../views/laporan/LapOverlapNotice';
import LapDuplikatNopolAktif from '../views/laporan/LapDuplikatNopolAktif';
import LapAuditNik from '../views/laporan/LapAuditNik';
import LapBaBatalSkpd from '../views/laporan/LapBaBatalSkpd';

import CancelNotice from '../views/transaksi/CancelNotice';
import HistoriNotice from '../views/transaksi/HistoriNotice';
import ValidasiSetoran from "../views/transaksi/ValidasiSetoran";

import Notice from '../views/notice/Notice';

import LapSwdkllj from '../views/laporan/LapSwdkllj';

import LapKasir from '../views/laporan/LapKasir';
import LapTeller from '../views/laporan/LapTeller';
import LapPerRekening from '../views/laporan/LapPerRekening';

import LapCetakStnk from '../views/laporan/LapCetakStnk';

import LapBendaharaPenerimaan from '../views/laporan/LapBendaharaPenerimaan';

import LapPenetapanPkb from '../views/laporan/LapPenetapanPkb';

import LapPenerimaanPkbWarnaPlat from '../views/laporan/LapPenerimaanPkbWarnaPlat';

import LapRealisasiPenerimaan from '../views/laporan/LapRealisasiPenerimaan';

import Pemutihan from '../views/laporan/Pemutihan';

import LaporanPnbp from '../views/laporan/LaporanPnbp';

import LapStss from '../views/laporan/LapStss';
import StsHarian from '../views/laporan/StsHarian';

import DataJabatan from '../views/jabatan/DataJabatan';
import FormJabatan from '../views/jabatan/FormJabatan';

import DataUpt from '../views/upt/DataUpt';
import FormUpt from '../views/upt/FormUpt';

import DataBidang from '../views/bidang/DataBidang';
import FormBidang from '../views/bidang/FormBidang';

import DataPegawai from '../views/pegawai/DataPegawai';
import FormPegawai from '../views/pegawai/FormPegawai';

import DataTandaTanganLaporan from '../views/tanda_tangan_laporan/DataTandaTanganLaporan';
import FormTandaTanganLaporan from '../views/tanda_tangan_laporan/FormTandaTanganLaporan';

import DataPengaturanPrinter from '../views/printer/DataPengaturanPrinter';
import FormPengaturanPrinter from '../views/printer/FormPengaturanPrinter';
import StatusPrinter from '../views/printer/StatusPrinter';

import DataTargetPendapatan from '../views/target_pendapatan/DataTargetPendapatan';
import FormTargetPendapatan from '../views/target_pendapatan/FormTargetPendapatan';

import DataMigrasi from '../views/migrasi/DataMigrasi';

import Umum from '../views/umum/Umum';

import LogAktivitasSaya from '../views/activitylog/LogAktivitasSaya';
import LogAktivitasAdmin from '../views/activitylog/LogAktivitasAdmin';
import DataJasaraharja from '../views/transaksi/DataJasaraharja';
import DataSmdd from '../views/transaksi/DataSmdd';
import DataKoreksiNomorNotice from '../views/transaksi/DataKoreksiNomorNotice';
import SinkronNotice from '../views/transaksi/SinkronNotice';
import AuditNoticeRusak from '../views/transaksi/AuditNoticeRusak';
import ResendJasaRaharja from '../views/transaksi/ResendJasaRaharja';
import UjiSilangSWD from '../views/transaksi/UjiSilangSWD';
import LapSUM32 from '../views/laporan/LapSum32';

import DataDiskon from '../views/diskon/DataDiskon';
import FormDiskon from '../views/diskon/FormDiskon';
import DataRewardDiskon from '../views/reward_diskon/DataRewardDiskon';
import FormRewardDiskon from '../views/reward_diskon/FormRewardDiskon';
import DataHariLibur from '../views/hari_libur/DataHariLibur';
import FormHariLibur from '../views/hari_libur/FormHariLibur';
import DataApiKey from '../views/apikey/DataApiKey';
import DataMacAddress from '../views/mac_address/DataMacAddress';
import FormPrintClientConfig from '../views/secrets/FormPrintClientConfig';
import DataMigrasiLegacyNotice from '../views/migrasi_legacy_notice/DataMigrasiLegacyNotice';
import DataIwkbu from '../views/iwkbu/DataIwkbu';

import DataWaktuOperasional from '../views/waktu_operasional/DataWaktuOperasional';
import FormWaktuOperasional from '../views/waktu_operasional/FormWaktuOperasional';

import DataImportNjkb from '../views/njkb/DataImportNjkb';

import AnalisaPotensiPkb from '../views/analitik/AnalisaPotensiPkb';
import TunggakanKendaraan from '../views/analitik/TunggakanKendaraan';
import ListTunggakanKendaraan from '../views/analitik/ListTunggakanKendaraan';

import moment from 'moment';
import debounce from 'lodash.debounce';

import 'moment/locale/id'  // without this line it didn't work
import FormPenetapanBiayaEri from "../views/transaksi/FormPenetapanBiayaEri";
import ErrorAlertModal from '../components/ErrorAlertModal';
moment.locale('id')

// import Forbidden from '../views/forbidden/Forbidden';
// import { askForPermissioToReceiveNotifications, logoutFirebase } from '../push-notification';

const { Content } = Layout;
let inOneHours = new Date(new Date().getTime() + 60 * 60 * 1000);
let reconnectAttempts = 0;

const buildFotoUrl = (path) => {
	if (!path) return null;
	if (path.startsWith('http')) return path;
	const base = (apiClient.defaults.baseURL || '').replace(/\/$/, '');
	return base ? base + path : path;
};

const configClass = {
	apiUrl: {
		userProfile: "auth/api/user/info/",
		upt: "pegawai/api/upt/",
		kabupaten: "master/api/kabupaten/",
		pegawai: "pegawai/api/pegawai/set_upt/",
		notice: "kendaraan/api/pengaturan/notice/",
		box: "gudangnotice/api/box/",
		legacyPending: "gudangnotice/api/box/legacy-pending/",
		migrasiLegacy: "gudangnotice/api/box/migrasi-legacy/",
		pengumuman: "master/api/pengumuman/",
	}
}

// Auto-logout setelah tidak ada aktivitas user selama durasi ini - selaras
// dengan IDLE_TIMEOUT_SECONDS di be/samsat/authentication.py (30 menit),
// supaya user benar-benar logout tepat saat backend juga menganggap sesi habis.
const IDLE_LOGOUT_MS = 30 * 60 * 1000; // 30 menit
const IDLE_WARNING_LEAD_MS = 60 * 1000; // tampilkan modal peringatan 1 menit sebelum logout
const IDLE_RESET_THROTTLE_MS = 5000; // batasi reset timer maksimal tiap 5 detik (mousemove dkk bisa beruntun)
const IDLE_ACTIVITY_EVENTS = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll', 'visibilitychange'];

// Cek update build - lihat fe/scripts/stamp-version.js untuk cara meta.json
// & src/buildInfo.json (di-import di atas) dihasilkan saat build:staging /
// build:production. Poll berkala + saat tab kembali aktif, supaya tab yang
// dibiarkan terbuka seharian (kasir) tetap dikasih tahu ada versi baru -
// header no-cache di nginx/Cloudflare cuma menolong tab BARU/reload, bukan
// tab yang sudah lama terbuka dan tak pernah minta index.html lagi.
const UPDATE_CHECK_INTERVAL_MS = 5 * 60 * 1000; // 5 menit

const TIPE_CONFIG = {
	backend:  { color: '#1890ff', bg: '#e6f7ff', border: '#91d5ff', icon: <CodeOutlined />, label: 'Backend' },
	frontend: { color: '#fa8c16', bg: '#fff7e6', border: '#ffd591', icon: <DesktopOutlined />, label: 'Frontend' },
	umum:     { color: '#52c41a', bg: '#f6ffed', border: '#b7eb8f', icon: <InfoCircleOutlined />, label: 'Umum' },
};

class AdminLayout extends React.Component {
	// Satu-satunya sumber kebenaran batas mobile utk shell layout (Sider vs
	// MobileBottomNav). WAJIB sama dengan media query mobile di style.css.
	static MOBILE_QUERY = 'only screen and (max-width: 768.98px)';

	config;
	formRef = React.createRef();

	constructor(props) {
		super(props);
		this.config = new Config();
		this.ws = null;
		this._heartbeatInterval = null;
		this.user = Cookies.get(this.config.get_cookie_name() + "_username").split("_");
		this.activeUsersWS            = null;
		this._activeUsersReconnectTimer = null;
		this._idleTimer = null;
		this._idleWarningTimer = null;
		this._countdownInterval = null;
		this._lastActivityAt = 0;
		this._updateCheckInterval = null;
		this._onVisibilityCheckUpdate = null;
		this.state = {
			counter: 3,
			idleWarningVisible: false,
			idleWarningCountdown: 60,
			isForbidden: false,
			isModalUpt: false,
			listUpt: [],
			loadingUpt: true,
			modalUptStep: 2,
			listKabupaten: [],
			loadingKabupaten: false,
			selectedKabupaten: null,

			errPilihUpt: null,
			loadingPilihUpt: false,

			isNotice: false,
			modalNotice: false,
			modalKonfirNotice: false,
			status_notice: false,
			loadingBoxList: false,
			listBox: [],

			// Paksa Migrasi Legacy Notice (UPT belum pernah punya BoxNotice
			// sama sekali) - tampil DUDULUAN, gantikan total modal Pengaturan
			// Notice manual selama status belum 'disetujui'. Lihat
			// getWaktuHabis migrasi_legacy_wajib/migrasi_legacy_status
			// (be/authentication/serializer.py) & memori
			// project_gudang_notice_cegah_tumpang_tindih_produksi.md.
			modalMigrasiLegacy: false,
			migrasiLegacyStatus: null, // 'belum' | 'pending'
			loadingSaranMigrasiLegacy: false,
			migrasiLegacySaran: null,
			migrasiKodeLegacy: '',
			migrasiAwalLegacy: undefined,
			migrasiAkhirLegacy: undefined,
			loadingSubmitMigrasiLegacy: false,
			loadingRefreshMigrasiLegacy: false,
			errTitleMigrasiLegacy: '',
			errMsgMigrasiLegacy: '',

			// Notifikasi update build baru (lihat UPDATE_CHECK_INTERVAL_MS)
			updateAvailable: false,
			updateMeta: null,

			aksi: 'tambah',
			method: 'post',
			idLama: '',
			errMsg: '',

			// Papan Pengumuman
			pengumuman: [],
			loadingPengumuman: false,
			isModalPengumuman: false,
			formPengumuman: { judul: '', isi: '', tipe: 'umum', versi: '' },
			editPengumuman: null,
			isEditModalPengumuman: false,
			loadingTogglePengumuman: null,
			submitPengumuman: false,

			// Batal Notice Notifikasi
			isCancelNoticeDrawer: false,
			cancelNoticePendingList: [],
			loadingCancelNotice: false,
			cancelNoticePollingId: null,

			// Drawer state
			isPengumumanDrawer: false,
			isUserAktifDrawer: false,
			activeUsers: [],
			activeUsersCount: 0,
			loadingActiveUsers: false,
		}
	}

	handleCloseDrawer = () => {
		this.props.setConfig({ collapsed: true });
		// console.log('cookies', Cookies.get(this.config.get_cookie_name()));
	// 	console.log('drawer_close', this.props.collapsed);
	}

	componentDidMount() {
		// if (!("Notification" in window)) {
		//     alert("browser tidak support notifikasi, notifikasi chat tidak akan aktif di browser ini");
		// }else if(Notification.permission != "denied"){
		// 	Notification.requestPermission().then(function (permission) {
		//       // If the user accepts, let's create a notification
		//       if (permission == "granted") {
		//         //var notification = new Notification("notifikasi berhasil diaktifkan!");
		//       }
		//     });
		// }
		// this.connect();
    	// this.socket.addEventListener("open", () => {
		// window.addEventListener("beforeunload", () => {
		// 	this.socket.close(1000, "Menutup karena halaman ditutup");
		// });
		// this.connectWebSocket();
		
		

		this.getProfile();
		this.getPengumuman();
		this.startIdleWatcher();
		this.startUpdateChecker();
		// Polling batal notice sebagai fallback (hanya untuk Kasi Penetapan)
		this.startCancelNoticePolling();
		// WebSocket realtime batal notice (menggantikan kebutuhan reload manual)
		this._connectBatalNoticeWS();
		// c0ki3s.set(...)
		// Query eksplisit (bukan default enquire-js 767.99px) supaya batasnya
		// SAMA PERSIS dengan blok CSS mobile di style.css (768.98px). Kalau
		// beda 0.01px saja, zoom/DPR fraksional bisa membuat lebar viewport
		// jatuh di celahnya: JSX mode mobile (bottom nav, tanpa Sider) tapi
		// CSS masih desktop (margin-left 256px) -> konten terjepit. Batas
		// <=768 dipilih agar iPad Mini portrait (768x1024) dapat layout mobile.
		this.enquireHandler = enquireScreen(mobile => {
			const { isMobile } = this.props
			if (isMobile != mobile) {
				this.props.setConfig({
					isMobile: mobile
				});
				if (mobile) {
					this.props.setConfig({
						collapsed: false
					});
				}
			}
		}, AdminLayout.MOBILE_QUERY);


		// if (this.props.location.pathname != "/admin/forbidden") {
		// 	setTimeout(() => {
		// 		this.cekRouteAccess();
		// 	}, 1000);
		// } else {
		// 	console.log('forbidden')
		// }

		// this.props.setConfig({
		// 	listUpt: [
		// 		{
		// 			id: 1,
		// 			nama: "UPT Kab Bantul"
		// 		},
		// 		{
		// 			id: 2,
		// 			nama: "UPT Kab Sleman"
		// 		},
		// 		{
		// 			id: 3,
		// 			nama: "UPT Kab Wates"
		// 		},
		// 		{
		// 			id: 4,
		// 			nama: "UPT Kab Yogyakarta"
		// 		},
		// 		{
		// 			id: 5,
		// 			nama: "UPT Kab Wonosari"
		// 		}
		// 	]
		// })

		// setTimeout(() => {
		// 	if (Cookies.get(this.config.get_cookie_name() + "_upt") == undefined) {
		// 		this.setState({
		// 			// isModalUpt: true
		// 		})

		// 	}

		// }, 100)
	}
	

	closeModal(){
		console.log('tutup');
		this.setState({
			modalKonfirNotice: false,
		});
	}
	clearCokies(){
		Cookies.remove(this.config.get_cookie_name());
		Cookies.remove(this.config.get_cookie_name() + "_upt");
		Cookies.remove(this.config.get_cookie_name() + "_isNotice");
		Cookies.remove(this.config.get_cookie_name() + "_username");
		Cookies.remove(this.config.get_cookie_name() + "_expired");
		this.props.setConfig({
			uptDipilih: "",
			isLogin: false,
			username: '',
			nama: '',
			id: '',
			pp: '',
			alamat: '',
			no_hp: '',
			layanan_id: [],
			layanan_str: [],
		});
		this.socket.close();
		// window.location.reload();
	}

	// --- Auto-logout karena idle (tidak ada aktivitas selama IDLE_LOGOUT_MS) ---
	startIdleWatcher = () => {
		this._lastActivityAt = Date.now();
		this.resetIdleTimer();
		IDLE_ACTIVITY_EVENTS.forEach(evt => window.addEventListener(evt, this.handleUserActivity));
	}

	stopIdleWatcher = () => {
		clearTimeout(this._idleTimer);
		clearTimeout(this._idleWarningTimer);
		this._stopCountdownTick();
		this._idleTimer = null;
		this._idleWarningTimer = null;
		IDLE_ACTIVITY_EVENTS.forEach(evt => window.removeEventListener(evt, this.handleUserActivity));
	}

	resetIdleTimer = () => {
		clearTimeout(this._idleTimer);
		clearTimeout(this._idleWarningTimer);
		this._stopCountdownTick();
		if (this.state.idleWarningVisible) this.setState({ idleWarningVisible: false });
		this._idleTimer = setTimeout(this.handleIdleLogout, IDLE_LOGOUT_MS);
		this._idleWarningTimer = setTimeout(this.showIdleWarning, IDLE_LOGOUT_MS - IDLE_WARNING_LEAD_MS);
	}

	// Modal peringatan 1 menit sebelum handleIdleLogout benar-benar jalan -
	// timernya di-set bersamaan dengan _idleTimer di resetIdleTimer (cuma
	// beda offset IDLE_WARNING_LEAD_MS), jadi kalau hitung mundur ini habis
	// tanpa aktivitas, _idleTimer yang memang sudah berjalan paralel akan
	// otomatis memanggil handleIdleLogout - tidak perlu dipicu manual di sini.
	showIdleWarning = () => {
		const deadline = Date.now() + IDLE_WARNING_LEAD_MS;
		this.setState({ idleWarningVisible: true, idleWarningCountdown: Math.round(IDLE_WARNING_LEAD_MS / 1000) });
		this._countdownInterval = setInterval(() => {
			const remaining = Math.max(0, Math.round((deadline - Date.now()) / 1000));
			this.setState({ idleWarningCountdown: remaining });
			if (remaining <= 0) this._stopCountdownTick();
		}, 1000);
	}

	_stopCountdownTick = () => {
		if (this._countdownInterval) {
			clearInterval(this._countdownInterval);
			this._countdownInterval = null;
		}
	}

	// --- Notifikasi update build baru ---
	startUpdateChecker = () => {
		this.checkForUpdate();
		this._updateCheckInterval = setInterval(this.checkForUpdate, UPDATE_CHECK_INTERVAL_MS);
		// Tab yang dibiarkan terbuka lama baru "sadar" ada update saat user
		// balik ke tab ini (mis. laptop sempat sleep / pindah tab berjam-jam) -
		// jangan tunggu siklus interval berikutnya.
		this._onVisibilityCheckUpdate = () => { if (!document.hidden) this.checkForUpdate(); };
		document.addEventListener('visibilitychange', this._onVisibilityCheckUpdate);
	}

	stopUpdateChecker = () => {
		if (this._updateCheckInterval) {
			clearInterval(this._updateCheckInterval);
			this._updateCheckInterval = null;
		}
		if (this._onVisibilityCheckUpdate) {
			document.removeEventListener('visibilitychange', this._onVisibilityCheckUpdate);
			this._onVisibilityCheckUpdate = null;
		}
	}

	// Render isi modal update - pesan (package.json "releaseMessage", lihat
	// scripts/stamp-version.js) boleh multi-baris (pisah "\n") utk daftar
	// poin perbaikan, dirender sbg bullet list. Pesan 1 baris (format lama,
	// mis. "URGENT: ...") tetap tampil sbg teks biasa - tidak berubah.
	renderUpdateMessage = () => {
		const raw = (this.state.updateMeta && this.state.updateMeta.message) || '';
		const lines = raw.split('\n').map((l) => l.trim().replace(/^[-•]\s*/, '')).filter(Boolean);
		if (lines.length === 0) {
			return 'Muat ulang halaman untuk mendapatkan pembaruan terbaru.';
		}
		if (lines.length === 1) {
			return lines[0];
		}
		return (
			<ul style={{ margin: 0, paddingLeft: 18 }}>
				{lines.map((line, i) => <li key={i}>{line}</li>)}
			</ul>
		);
	}

	checkForUpdate = () => {
		if (this.state.updateAvailable) return; // sudah tampil, tak perlu cek ulang
		fetch('/meta.json', { cache: 'no-store' })
			.then(res => (res.ok ? res.json() : null))
			.then(meta => {
				if (meta && meta.release && meta.release !== buildInfo.release) {
					this.setState({ updateAvailable: true, updateMeta: meta });
				}
			})
			.catch(() => {}); // diam-diam gagal (offline dsb) - dicoba lagi siklus berikutnya
	}

	handleUserActivity = (e) => {
		if (e.type === 'visibilitychange' && document.hidden) return;

		// throttle: jangan reset timer di setiap event (mousemove bisa beruntun puluhan kali per detik)
		const now = Date.now();
		if (now - this._lastActivityAt < IDLE_RESET_THROTTLE_MS) return;
		this._lastActivityAt = now;
		this.resetIdleTimer();
	}

	handleIdleLogout = () => {
		if (!this.props.isLogin) return;

		this._stopCountdownTick();

		// beri tahu backend supaya session di Redis ikut dihapus & koneksi device lain (kalau ada) ikut tersinkron
		if (this.socket && this.socket.readyState === WebSocket.OPEN) {
			this.socket.send(JSON.stringify({ type: 'logout', username: this.user[2], device_id: localStorage.getItem("device_id") }));
			this.socket.close(1000, 'Idle logout');
		}

		this.stopIdleWatcher();

		// Tampilkan modal (bukan toast) supaya user sadar sesinya berakhir
		// karena idle, bukan diam-diam ter-redirect. Sesi baru benar-benar
		// dibersihkan (cookies + redirect ke login) saat user klik "Oke" -
		// reuse modalLogout & clearCokies() yang sudah ada, sama seperti
		// modal saat login di perangkat lain. Kalau clearLocalSession
		// dipanggil di sini juga (bukan di tombol), isLogin langsung false
		// dan AdminLayout ini ikut ter-unmount sebelum modal sempat terlihat.
		this.setState({
			idleWarningVisible: false,
			modalLogout: true,
			pesan_logout: 'Anda telah logout otomatis karena tidak ada aktivitas selama 30 menit.',
		});
	}

	async connectWebSocket(){
		this.config = new Config();
		const user = Cookies.get(this.config.get_cookie_name() + "_username").split("_");
		
		// ✅ Cek apakah WebSocket sudah aktif
		if (this.socket && this.socket.readyState == WebSocket.OPEN) {
			this.socket.send(JSON.stringify({ type: 'refresh_page', username: this.user[2], device_id: localStorage.getItem("device_id") }));
			console.warn("WebSocket sudah aktif. Reconnect dibatalkan.");
			return;
		}
		
		// ✅ Optional: jika socket masih di CONNECTING atau CLOSING, bisa ditutup dulu
		if (this.socket && this.socket.readyState != WebSocket.CLOSED) {
			this.socket.close();
			this.socket = null;
		}

		// this.socket = new WebSocket(this.config.get_web_socket()+"/ws/cek-status/");

		// 🌐 Inisialisasi koneksi baru
		// ws/cek-status sekarang wajib JWT (lihat samsat/consumers.py DeviceConsumer,
		// require_auth=True) - sama seperti ws/active-users & ws/batal-notice di bawah.
		const rawTokenCekStatus = Cookies.get(this.config.get_cookie_name()) || '';
		const tokenCekStatus = rawTokenCekStatus.replace('Bearer ', '').trim();
    	this.socket = new WebSocket(this.config.get_web_socket()+`/ws/cek-status/${user[2]}/?token=${tokenCekStatus}&device_id=${localStorage.getItem("device_id")}/`);
		// Daftarkan ke registry supaya komponen lain (header/sider/bottom-nav)
		// bisa kirim logout lewat socket ini tanpa membuka WS baru.
		registerDeviceSocket(this.socket);

		this.socket.onopen = () => {
			reconnectAttempts = 0;
			if (this.socket.readyState == WebSocket.OPEN && localStorage.getItem("logout") == "false") {
				this.socket.send(JSON.stringify({ type: 'refresh_page', username: this.user[2], device_id: localStorage.getItem("device_id") }));
			} else {
				message.error({ content: "Sesi Anda telah berakhir.", duration: 8, key: 'toast'});
				this.setState({
					modalLogout: true,
					pesan_logout: "Sesi Anda telah berakhir karena akun ini digunakan untuk login di perangkat lain. Silakan login kembali jika ini bukan Anda.",
				});
			}
			// Heartbeat setiap 60 detik — menjaga session Redis tetap hidup
			if (this._heartbeatInterval) clearInterval(this._heartbeatInterval);
			this._heartbeatInterval = setInterval(() => {
				if (this.socket && this.socket.readyState === WebSocket.OPEN) {
					this.socket.send(JSON.stringify({
						type: 'heartbeat',
						device_id: localStorage.getItem("device_id"),
					}));
				}
			}, 60000);
		};

		this.socket.onmessage = (event) => {
			const data = JSON.parse(event.data);
			// FIX: konsumer backend (samsat/consumers.py DeviceConsumer.force_logout)
			// hanya meneruskan pesan ini ke socket yang device_id-nya SUDAH cocok
			// dengan device_id di event (lihat gate "if event['device_id'] == self.device_id"
			// sebelum safe_send dipanggil) - jadi kalau pesan ini sampai ke sini,
			// device_id-nya SUDAH PASTI sama dengan device ini sendiri, bukan beda.
			// Sebelumnya pakai "!=" (salah arah) sehingga modal logout tidak pernah
			// muncul walau koneksi sudah ditutup paksa oleh server.
			if (data.user == user[2] && data.device_id == localStorage.getItem("device_id") && data.logout == true) {
				message.error({ content: "Sesi Anda telah berakhir.", duration: 8, key: 'toast'});
				this.setState({
					modalLogout: true,
					// Pesan distandarkan di frontend (bukan pakai data.message dari
					// server) supaya konsisten terlepas dari sumber trigger-nya
					// (paksa-login di be/samsat/views.py atau jalur lawas di consumers.py).
					pesan_logout: "Sesi Anda telah berakhir karena akun ini digunakan untuk login di perangkat lain. Silakan login kembali jika ini bukan Anda.",
				});
        		localStorage.setItem("logout", true);
			}
			if (data.user == user[2] && data.device_id == localStorage.getItem("device_id") && data.logout == false) {
				// console.log('cek',data)
				if (data.message != ""){
					message.success({ content: `${data.message}`, duration: 8, key: 'toast'});
				}
			}
			if (data.user == user[2] && data.device_id == localStorage.getItem("device_id") && data.status == 2) {
				if (data.message != ""){
					message.error({ content: `${data.message}`, duration: 8, key: 'toast'});
				}
			}
		};

		this.socket.onclose = (event) => {
			if (this._heartbeatInterval) {
				clearInterval(this._heartbeatInterval);
				this._heartbeatInterval = null;
			}
			if (!event.wasClean) {
				let delay = Math.min(30000, Math.pow(2, reconnectAttempts) * 1000); // Maksimum 30 detik
				message.error({ content: `Koneksi putus, menghubungkan ulang dalam ${delay / 1000} detik...`, duration: 5, key: 'toast' });
				setTimeout(() => {
					reconnectAttempts++;
					const cookieName = this.config.get_cookie_name() + "_username";
					const raw = Cookies.get(cookieName);
					if (typeof raw == "string" && raw.includes("_")) {
						this.connectWebSocket();
					} else {
						// console.warn("Cookie tidak ditemukan atau format tidak sesuai");
						message.error({ content: "Anda telah logout!", duration: 6, key: 'toast'});
						clearLocalSession(this.props.setConfig);
					}
				}, delay);
			};
		};

		this.socket.onerror = (error) => {
			message.error({ content: `Error pada WebSocket: ${error} Hubungi Admin`, duration: 5, key: 'toast' });
		};

    	return () => this.socket.close();
	};

	// ─── Papan Pengumuman ──────────────────────────────────────────
	async getPengumuman() {
		this.setState({ loadingPengumuman: true });
		this.props.ajaxViewHandler('get', configClass.apiUrl.pengumuman + '?limit=50')
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					const list = Array.isArray(data) ? data : (data.results || []);
					this.setState({ pengumuman: list });

					// Hitung pengumuman 1 bulan terakhir untuk badge sidebar
					const sebulanLalu = new Date();
					sebulanLalu.setMonth(sebulanLalu.getMonth() - 1);
					const jumlahBaru = list.filter(p =>
						p.is_aktif && p.created_at && new Date(p.created_at) >= sebulanLalu
					).length;
					this.props.setConfig({ pengumumanBadgeCount: jumlahBaru });
				}
				this.setState({ loadingPengumuman: false });
			})
			.catch(() => this.setState({ loadingPengumuman: false }));
	}

	// ─── Batal Notice Notification (Kasi Penetapan) ──────────────
	startCancelNoticePolling() {
		const akses = this.props.akses;
		if (!akses || !akses.transaksi_cancle_notice_approve) return;
		if (this.state.cancelNoticePollingId) return; // sudah berjalan
		this.fetchCancelNoticePending();
		const id = setInterval(() => this.fetchCancelNoticePending(), 2 * 60 * 1000);
		this.setState({ cancelNoticePollingId: id });
	}

	async fetchCancelNoticePending() {
		const akses = this.props.akses;
		if (!akses || !akses.transaksi_cancle_notice_approve) return;
		this.props.ajaxViewHandler('get', 'transaksi/api/permintaan-batal-notice/pending-count/')
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					this.props.setConfig({ cancelNoticePendingCount: data.count || 0 });
				}
			})
			.catch(() => {});
	}

	async fetchCancelNoticePendingList() {
		this.setState({ loadingCancelNotice: true });
		this.props.ajaxViewHandler('get', 'transaksi/api/permintaan-batal-notice/?status=pending')
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					const list = Array.isArray(data) ? data : (data.results || []);
					this.setState({ cancelNoticePendingList: list });
					this.props.setConfig({ cancelNoticePendingCount: list.length });
				}
				this.setState({ loadingCancelNotice: false });
			})
			.catch(() => this.setState({ loadingCancelNotice: false }));
	}

	async submitFormPengumuman() {
		const { formPengumuman } = this.state;
		if (!formPengumuman.judul.trim() || !formPengumuman.isi.trim()) return;
		this.setState({ submitPengumuman: true });
		this.props.ajaxHandler('post', configClass.apiUrl.pengumuman, formPengumuman, false, true)
			.then(() => {
				if (this.props.isSuccess) {
					message.success('Pengumuman berhasil disimpan.');
					this.setState({ isModalPengumuman: false, formPengumuman: { judul: '', isi: '', tipe: 'umum', versi: '' } });
					this.getPengumuman();
				} else {
					message.error('Gagal menyimpan pengumuman.');
				}
				this.setState({ submitPengumuman: false });
			})
			.catch(() => { message.error('Gagal menyimpan pengumuman.'); this.setState({ submitPengumuman: false }); });
	}

	async updatePengumuman() {
		const { editPengumuman } = this.state;
		if (!editPengumuman?.judul?.trim() || !editPengumuman?.isi?.trim()) return;
		this.setState({ submitPengumuman: true });
		this.props.ajaxHandler('put', configClass.apiUrl.pengumuman + editPengumuman.id + '/', editPengumuman, false, true)
			.then(() => {
				if (this.props.isSuccess) {
					message.success('Pengumuman berhasil diperbarui.');
					this.setState({ isEditModalPengumuman: false, editPengumuman: null });
					this.getPengumuman();
				} else {
					message.error('Gagal memperbarui pengumuman.');
				}
				this.setState({ submitPengumuman: false });
			})
			.catch(() => { message.error('Gagal memperbarui pengumuman.'); this.setState({ submitPengumuman: false }); });
	}

	async togglePengumuman(item) {
		this.setState({ loadingTogglePengumuman: item.id });
		this.props.ajaxHandler('patch', configClass.apiUrl.pengumuman + item.id + '/', { is_aktif: !item.is_aktif }, false, true)
			.then(() => {
				if (this.props.isSuccess) {
					message.success(!item.is_aktif ? 'Pengumuman diaktifkan.' : 'Pengumuman dinonaktifkan.');
					this.getPengumuman();
				} else {
					message.error('Gagal mengubah status pengumuman.');
				}
				this.setState({ loadingTogglePengumuman: null });
			})
			.catch(() => { this.setState({ loadingTogglePengumuman: null }); });
	}

	// ─── User Aktif WebSocket ───────────────────────────────────────
	// Satu-satunya pemilik koneksi ws/active-users (Home membaca via redux).
	// Backend hanya menerima superuser / level_user <= 2 dengan JWT valid.
	_connectActiveUsersWS(levelUser) {
		if (this.activeUsersWS) return;
		const lvl = levelUser != null ? levelUser : (this.props.level_user || 3);
		if (lvl > 2) return;
		const wsBase = this.config.get_web_socket().replace(/\/+$/, '');

		const openSocket = (token) => {
			this.activeUsersWS = new WebSocket(`${wsBase}/ws/active-users/?token=${token}`);
			this.activeUsersWS.onmessage = (e) => {
				try {
					const msg = JSON.parse(e.data);
					if (msg.type === 'active_users' || msg.users) {
						const users = msg.users || [];
						this.setState({ activeUsers: users, activeUsersCount: users.length, loadingActiveUsers: false });
						this.props.setConfig({ activeUsersCount: users.length });
					}
				} catch {}
			};
			this.activeUsersWS.onclose = () => {
				this.activeUsersWS = null;
				if ((this.props.level_user || 3) <= 2) {
					this._activeUsersReconnectTimer = setTimeout(() => this._connectActiveUsersWS(), 5000);
				}
			};
		};

		// Refresh dulu sebelum connect/reconnect - cookie akses berumur pendek
		// (30 menit) dan koneksi WS ini TIDAK ikut silent-refresh otomatis milik
		// axios interceptor (store.js), yang cuma jalan saat ada REST call. Tanpa
		// ini, reconnect loop (onclose di atas) bisa terjebak pakai token basi
		// selamanya kalau tab dibiarkan idle tanpa aktivitas REST apa pun.
		getRefreshedAccessToken()
			.then((newAccess) => openSocket(newAccess))
			.catch(() => {
				// Tidak ada refresh token / refresh gagal - tetap coba pakai cookie
				// akses yang ada sekarang (mis. baru saja login, cookie masih fresh).
				const rawToken = Cookies.get(this.config.get_cookie_name()) || '';
				const token = rawToken.replace('Bearer ', '').trim();
				openSocket(token);
			});
	}

	// ─── Batal Notice WebSocket (Kasi Penetapan) ─────────────────
	_connectBatalNoticeWS() {
		const akses = this.props.akses;
		if (!akses || !akses.transaksi_cancle_notice_approve) return;
		if (this.batalNoticeWS && this.batalNoticeWS.readyState <= 1) return; // sudah connecting/open
		const wsBase = this.config.get_web_socket().replace(/\/+$/, '');
		// Kirim JWT token sebagai query param karena AuthMiddlewareStack pakai session,
		// sedangkan frontend pakai JWT sehingga scope['user'] selalu AnonymousUser
		const rawToken = Cookies.get(this.config.get_cookie_name()) || '';
		const token = rawToken.replace('Bearer ', '').trim();
		this.batalNoticeWS = new WebSocket(`${wsBase}/ws/batal-notice/?token=${token}`);

		this.batalNoticeWS.onopen = () => {
			if (this._batalNoticeReconnectTimer) {
				clearTimeout(this._batalNoticeReconnectTimer);
				this._batalNoticeReconnectTimer = null;
			}
		};

		this.batalNoticeWS.onmessage = (e) => {
			try {
				const data = JSON.parse(e.data);
				if (data.type !== 'new_request') return;

				// Update badge count
				const newCount = (this.props.cancelNoticePendingCount || 0) + 1;
				this.props.setConfig({ cancelNoticePendingCount: newCount });

				// Refresh list jika drawer sedang terbuka
				if (this.state.isCancelNoticeDrawer) {
					this.fetchCancelNoticePendingList();
				}

				// Tampilkan notifikasi popup
				const jenisLabel = data.jenis === 'rusak' ? '⚠ Notice Rusak' : '↩ Batal Validasi';
				notification.open({
					key: `batal-notice-${data.id}`,
					message: (
						<span style={{ fontWeight: 700, color: '#0f2847' }}>
							Permintaan Pembatalan Notice
						</span>
					),
					description: (
						<div>
							<div style={{ fontWeight: 600, fontSize: 14 }}>{data.nomor_polisi}</div>
							<div style={{ fontSize: 12, color: '#555', marginTop: 2 }}>
								{jenisLabel} &nbsp;·&nbsp; {data.upt_nama}
							</div>
							<div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>
								Diajukan: {data.diajukan_oleh}
							</div>
							{data.keterangan && (
								<div style={{ fontSize: 12, color: '#aaa', marginTop: 2, fontStyle: 'italic' }}>
									"{data.keterangan}"
								</div>
							)}
						</div>
					),
					icon: <BellOutlined style={{ color: '#faad14', fontSize: 20 }} />,
					duration: 10,
					style: {
						borderLeft: '4px solid #faad14',
						borderRadius: 8,
					},
					onClick: () => {
						this.setState({ isCancelNoticeDrawer: true });
						this.fetchCancelNoticePendingList();
						notification.close(`batal-notice-${data.id}`);
					},
				});
			} catch {}
		};

		this.batalNoticeWS.onclose = () => {
			this.batalNoticeWS = null;
			const akses = this.props.akses;
			if (akses && akses.transaksi_cancle_notice_approve) {
				this._batalNoticeReconnectTimer = setTimeout(() => this._connectBatalNoticeWS(), 5000);
			}
		};
	}

	loadActiveUsers() {
		if (this.activeUsersWS && this.activeUsersWS.readyState === WebSocket.OPEN) {
			this.setState({ loadingActiveUsers: true });
			this.activeUsersWS.send('refresh');
		}
	}

	componentDidUpdate(prevProps, prevState){
		// akses baru saja terisi (null → object) setelah getProfile() selesai
		// → inisialisasi polling dan WS batal notice yang sebelumnya gagal karena akses=null
		if (!prevProps.akses && this.props.akses) {
			this.startCancelNoticePolling();
			this._connectBatalNoticeWS();
		}

		// Trigger pindah UPT dari header (admin level 2)
		if (!prevProps.showPindahUptModal && this.props.showPindahUptModal) {
			this.props.setConfig({ showPindahUptModal: false });
			this.setState({
				isModalUpt: true,
				modalUptStep: 1,
				listUpt: [],
				listKabupaten: [],
				selectedKabupaten: null,
				errPilihUpt: null,
			}, () => {
				this.getKabupaten();
			});
		}

		// Buka drawer Papan Pengumuman dari sidebar
		if (!prevProps.openPengumumanPanel && this.props.openPengumumanPanel) {
			this.setState({ isPengumumanDrawer: true });
			this.props.setConfig({ openPengumumanPanel: false });
		}
		// Buka drawer Batal Notice Notification dari sidebar
		if (!prevProps.openCancelNoticeNotif && this.props.openCancelNoticeNotif) {
			this.setState({ isCancelNoticeDrawer: true });
			this.props.setConfig({ openCancelNoticeNotif: false });
			this.fetchCancelNoticePendingList();
		}
		// Buka drawer User Aktif dari sidebar — reset flag agar bisa dipanggil ulang
		if (!prevProps.openUserAktifPanel && this.props.openUserAktifPanel) {
			this.setState({ isUserAktifDrawer: true });
			this._connectActiveUsersWS();
			this.props.setConfig({ openUserAktifPanel: false });
		}
		// if (prevProps.location.pathname != this.props.location.pathname) {
		// 	console.log('prev_route', prevProps.location.pathname)
		// 	console.log('this_route', this.props.location.pathname)
		// 	if (this.props.location.pathname != "/admin/forbidden") {
		// 		setTimeout(() => {
		// 			console.log('jalan')
		// 			this.cekRouteAccess();
		// 		}, 1200);
		// 	} else {
		// 		console.log('forbidden2')
		// 		window.location.reload();
		// 	}
		// }
	}

	// cekRouteAccess() {
	// 	this.setState({
	// 		counter: 3
	// 	});
	// 	if (this.props.location.pathname != "/admin/forbidden") {
	// 		if (this.props.location.pathname == "/admin/tanda_tangan" && this.props.akses != null && this.props.akses != undefined && this.props.akses.master_tanda_tangan == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/negara" && this.props.akses != null && this.props.akses != undefined && this.props.akses.master_negara == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/merek" && this.props.akses != null && this.props.akses != undefined && this.props.akses.master_merek == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/tipe" && this.props.akses != null && this.props.akses != undefined && this.props.akses.master_Tipe == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/jenis-kendaraan" && this.props.akses != null && this.props.akses != undefined && this.props.akses.master_jenis_kendaraan == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/bahan-bakar" && this.props.akses != null && this.props.akses != undefined && this.props.akses.master_bahan_bakar == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/warna" && this.props.akses != null && this.props.akses != undefined && this.props.akses.master_warna == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/pekerjaan" && this.props.akses != null && this.props.akses != undefined && this.props.akses.master_pekerjaan == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/kepemilikan" && this.props.akses != null && this.props.akses != undefined && this.props.akses.master_kepemilikan == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/layanan" && this.props.akses != null && this.props.akses != undefined && this.props.akses.master_layanan == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/dealer" && this.props.akses != null && this.props.akses != undefined && this.props.akses.master_dealer == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/payment" && this.props.akses != null && this.props.akses != undefined && this.props.akses.master_payment == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/golongan" && this.props.akses != null && this.props.akses != undefined && this.props.akses.master_golongan == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/warna-plat" && this.props.akses != null && this.props.akses != undefined && this.props.akses.master_warna_plat == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/fungsi" && this.props.akses != null && this.props.akses != undefined && this.props.akses.master_fungsi == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/jabatan" && this.props.akses != null && this.props.akses != undefined && this.props.akses.pegawai_jabatan == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/upt" && this.props.akses != null && this.props.akses != undefined && this.props.akses.pegawai_upt == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/bidang" && this.props.akses != null && this.props.akses != undefined && this.props.akses.pegawai_bidang == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/pegawai" && this.props.akses != null && this.props.akses != undefined && this.props.akses.pegawai_pegawai == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/pengaturan/njkb" && this.props.akses != null && this.props.akses != undefined && this.props.akses.pengaturan_njkb == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/pengaturan/swdkllj" && this.props.akses != null && this.props.akses != undefined && this.props.akses.pengaturan_swdkllj == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/pengaturan/admstnk" && this.props.akses != null && this.props.akses != undefined && this.props.akses.pengaturan_adm_stnk == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/pengaturan/admtnkb" && this.props.akses != null && this.props.akses != undefined && this.props.akses.pengaturan_adm_tnkb == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/pengaturan/denda-pkb" && this.props.akses != null && this.props.akses != undefined && this.props.akses.pengaturan_denda_pkb == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/pengaturan/denda-swdkllj" && this.props.akses != null && this.props.akses != undefined && this.props.akses.pengaturan_denda_swdkllj == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/pengaturan/notice" && this.props.akses != null && this.props.akses != undefined && this.props.akses.pengaturan_notice == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/informasi/informasi-kendaraan" && this.props.akses != null && this.props.akses != undefined && this.props.akses.informasi_informasi_kendaraan == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/informasi/cari-data-kbm" && this.props.akses != null && this.props.akses != undefined && this.props.akses.informasi_cari_data_kbm == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/transaksi/pendaftaran" && this.props.akses != null && this.props.akses != undefined && this.props.akses.transaksi_pendaftaran == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/transaksi/penetapan-biaya" && this.props.akses != null && this.props.akses != undefined && this.props.akses.transaksi_penetapan == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/transaksi/surat-keterangan-fiskal" && this.props.akses != null && this.props.akses != undefined && this.props.akses.transaksi_surat_keterangan_fiskal == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/transaksi/pembayaran" && this.props.akses != null && this.props.akses != undefined && this.props.akses.transaksi_pembayaran == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/transaksi/cancel-notice" && this.props.akses != null && this.props.akses != undefined && this.props.akses.transaksi_cancle_notice == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/laporan/bbnkb-pkb" && this.props.akses != null && this.props.akses != undefined && this.props.akses.laporan_penerimaan_bbnkb_pkb == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/laporan/notice" && this.props.akses != null && this.props.akses != undefined && this.props.akses.laporan_notice == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 		if (this.props.location.pathname == "/admin/laporan/notice-rusak" && this.props.akses != null && this.props.akses != undefined && this.props.akses.laporan_notice_rusak == false) {
	// 			this.setState({
	// 				isModalForbidden: true
	// 			});
	// 			this.doCounter();
	// 		}
	// 	}
	// }



	// doCounter() {
	// 	setTimeout(() => {
	// 		if (this.state.counter > 0) {
	// 			let temp = this.state.counter;
	// 			temp -= 1;
	// 			this.setState({
	// 				counter: temp
	// 			});
	// 			this.doCounter();
	// 		} else {
	// 			this.setState({
	// 				isForbidden: true
	// 			});
	// 		}
	// 	}, 1000);
	// }

	componentWillUnmount() {
		this.stopIdleWatcher();
		this.stopUpdateChecker();
		// Query harus disertakan lagi - unenquireScreen tanpa query akan
		// mencoba unregister dari default 767.99px dan handler tidak terlepas.
		unenquireScreen(this.enquireHandler, AdminLayout.MOBILE_QUERY);
		// Stop batal notice polling
		if (this.state.cancelNoticePollingId) {
			clearInterval(this.state.cancelNoticePollingId);
		}
		// Tutup WS batal notice
		if (this.batalNoticeWS) {
			this.batalNoticeWS.onclose = null; // cegah auto-reconnect saat unmount
			this.batalNoticeWS.close();
		}
		if (this._batalNoticeReconnectTimer) {
			clearTimeout(this._batalNoticeReconnectTimer);
		}
		// Tutup WS user aktif
		if (this.activeUsersWS) {
			this.activeUsersWS.onclose = null; // cegah auto-reconnect saat unmount
			this.activeUsersWS.close();
			this.activeUsersWS = null;
		}
		if (this._activeUsersReconnectTimer) {
			clearTimeout(this._activeUsersReconnectTimer);
		}
		// Lepas socket device dari registry + heartbeat
		if (this._heartbeatInterval) {
			clearInterval(this._heartbeatInterval);
			this._heartbeatInterval = null;
		}
		if (this.socket) {
			unregisterDeviceSocket(this.socket);
			this.socket.onclose = null;
			this.socket.close();
			this.socket = null;
		}
	}

	konak = () =>{
		// this.socket.onopen = () => {
		// 	// var connectInterval;
		// 	console.log("WebSocket Connected");

		// 	// this.timeout = 250; // reset timer to 250 on open of websocket connection 
		// 	// clearTimeout(connectInterval);
		// };

		// this.socket.onmessage = (event) => {
		// 	// console.log('ada login baru')
		// 	const data = JSON.parse(event.data);
		// 	const user = Cookies.get(this.config.get_cookie_name() + "_username").split("_");
		// 	console.log(data)
		// 	if (data.user == user[2] && data.pegawai[0].device_id != localStorage.getItem("device_id")) {
		// 	// if (data.user == user[2] && data.logout == true) {
		// 		alert(data.message);
		// 		Cookies.remove(this.config.get_cookie_name());
		// 		Cookies.remove(this.config.get_cookie_name() + "_upt");
		// 		Cookies.remove(this.config.get_cookie_name() + "_isNotice");
		// 		Cookies.remove(this.config.get_cookie_name() + "_username");
		// 		this.props.setConfig({
		// 			uptDipilih: "",
		// 			isLogin: false,
		// 			username: '',
		// 			nama: '',
		// 			id: '',
		// 			pp: '',
		// 			alamat: '',
		// 			no_hp: '',
		// 			layanan_id: [],
		// 			layanan_str: [],
		// 		});
		// 		// localStorage.removeItem("device_id");  // 🔥 Hapus device id atau sesi pengguna
		// 		window.location.reload();
		// 	};
		// };

		// this.socket.onerror = (error) => {
		// 	console.error("WebSocket Error:", error);
		// };

		// this.socket.onclose = () => {
		// 	console.log("WebSocket Disconnected layout");
		// };
	};


	// connect = () => {
	//         var ws = new WebSocket(this.config.get_web_socket()+"?token="+Cookies.get(this.config.get_cookie_name()).replace("Bearer ", ""));
	//         let that = this; // cache the this
	//         var connectInterval;

	//         // websocket onopen event listener
	//         ws.onopen = () => {
	//             console.log("web socket connected with token "+Cookies.get(this.config.get_cookie_name()).replace("Bearer ", ""));

	//             this.props.setConfig({
	//               ws: ws
	//             });

	//             that.timeout = 250; // reset timer to 250 on open of websocket connection 
	//             clearTimeout(connectInterval); // clear Interval on on open of websocket connection
	//         };

	//         ws.onmessage = evt => {
	//         	const pesan = JSON.parse(evt.data);
	// 		    //this.setState({dataFromServer: pesan});
	// 		    //console.log(pesan);
	// 		    if(pesan.status != null && pesan.status == 'online'){
	// 		    	//notif konek ke websocket
	// 		    }else{
	// 		    	// console.log('pesan_masuk', pesan);

	// 		    	if(pesan.tipe == 'Pembelian / Pemesanan Obat'){
	// 		    		notification['info']({
	// 					    message: pesan.tipe+' Baru',
	// 					    description: 'ada transaksi '+pesan.tipe+' Baru, silahkan konfirmasi segera.',
	// 					    placement: 'topRight'
	// 					});
	// 		    		this.props.setConfig({
	// 		    			latestId_PembelianObat: pesan.transaksi
	// 		    		});
	// 		    	}else if(pesan.tipe == 'Periksa Laboratorium'){
	// 		    		notification['info']({
	// 					    message: pesan.tipe+' Baru',
	// 					    description: 'ada transaksi '+pesan.tipe+' Baru, silahkan konfirmasi segera.',
	// 					    placement: 'topRight'
	// 					});
	// 		    		this.props.setConfig({
	// 		    			latestId_PeriksaLab: pesan.transaksi
	// 		    		});
	// 		    	}else if(pesan.tipe == 'Home Care'){
	// 		    		notification['info']({
	// 					    message: pesan.tipe+' Baru',
	// 					    description: 'ada transaksi '+pesan.tipe+' Baru, silahkan konfirmasi segera.',
	// 					    placement: 'topRight'
	// 					});
	// 		    		this.props.setConfig({
	// 		    			latestId_HomeCare: pesan.transaksi
	// 		    		});
	// 		    	}else if(pesan.tipe == 'Ambulan / Mobil Janazah'){
	// 		    		notification['info']({
	// 					    message: pesan.tipe+' Baru',
	// 					    description: 'ada transaksi '+pesan.tipe+' Baru, silahkan konfirmasi segera.',
	// 					    placement: 'topRight'
	// 					});
	// 		    		this.props.setConfig({
	// 		    			latestId_Ambulans: pesan.transaksi
	// 		    		});
	// 		    	}else if(pesan.tipe == 'Emergency Call'){
	// 		    		notification['info']({
	// 					    message: pesan.tipe+' Baru',
	// 					    description: 'ada transaksi '+pesan.tipe+' Baru, silahkan konfirmasi segera.',
	// 					    placement: 'topRight'
	// 					});
	// 		    		this.props.setConfig({
	// 		    			latestId_Emergency: pesan.transaksi
	// 		    		});
	// 		    	}


	// 			}

	//         };

	//         // websocket onclose event listener
	//         ws.onclose = e => {
	//             console.log(
	//                 `Socket is closed. Reconnect will be attempted in ${Math.min(
	//                     10000 / 1000,
	//                     (that.timeout + that.timeout) / 1000
	//                 )} second.`,
	//                 e.reason
	//             );

	//             that.timeout = that.timeout + that.timeout; //increment retry interval
	//             connectInterval = setTimeout(this.check, Math.min(10000, that.timeout)); //call check function after timeout
	//         };

	//         // websocket onerror event listener
	//         ws.onerror = err => {
	//             console.error(
	//                 "Socket encountered error: ",
	//                 err.message,
	//                 "Closing socket"
	//             );

	//             ws.close();
	//         };
	// };

	// /**
	//   * utilited by the @function connect to check if the connection is close, if so attempts to reconnect
	//   */
	// check = () => {
	//       const { ws } = this.props;
	//       if (!ws || ws.readyState == WebSocket.CLOSED) this.connect(); //check if websocket instance is closed, if so call `connect` function.
	// };

	

	async getProfile() {
		this.props.ajaxViewHandler('get', configClass.apiUrl.userProfile)
			.then(() => {
				const data = this.props.responseMsg;
				if (data != undefined) {
					if (data.detail != 'Data autentikasi tidak diberikan.'){
						// is_superuser di Redux merefleksikan data.is_superuser dari backend
						// secara langsung (sebelumnya terbalik - lihat FormPendaftaran.jsx
						// dan FormPendaftaranEri.jsx yang sudah disesuaikan jadi !is_superuser).
						if(data.is_superuser==true){
							this.props.setConfig({
								is_superuser : true,
							})
						}else{
							this.props.setConfig({
								is_superuser : false,
							})
						};
						this.props.setConfig({
							username: data.username,
							id: data.id,
							nama: data.pegawai[0].nama,
							pp: buildFotoUrl(data.pegawai[0].foto) || process.env.PUBLIC_URL + '/user.png',
							akses: data.access,
							waktu_akses: data.waktu_habis,
							isbypas: data.is_bypass,
							printer: data.pegawai[0].serial_printer != undefined ? data.pegawai[0].serial_printer : "pengaturan printer belum dipilih",
							nama_printer: data.pegawai[0].nama_printer != undefined ? data.pegawai[0].nama_printer : "pengaturan printer belum dipilih",
							level_user: data.pegawai[0].level_user || 3,
							kabupaten_id: data.pegawai[0].kabupaten_id || '',
							kabupaten_nama: data.pegawai[0].kabupaten_nama || '',
							upt_id: data.pegawai[0].upt_id || '',
						});
						// Monitor user aktif — koneksi tunggal milik layout, hanya level 1 & 2.
						// Dibuka sejak profil termuat supaya badge sidebar langsung live.
						this._connectActiveUsersWS(data.pegawai[0].level_user || 3);
					}else{
						message.error({ content: `Anda telah logout karena login dari perangkat lain!!!`, duration: 5, key: 'toast' });
						clearLocalSession(this.props.setConfig);
						// window.location.reload();
					}

					const cookieName = this.config.get_cookie_name() + "_username";
					const raw = Cookies.get(cookieName);
					// this.user = Cookies.get(this.config.get_cookie_name() + "_username").split("_");
					
					if (typeof raw == "string" && raw.includes("_")) {
						this.connectWebSocket();
					} else {
						console.warn("Cookie tidak ditemukan atau format tidak sesuai");
					}

					// Jabatan dengan bebas_pilih_upt + pegawai sudah punya UPT tetap (upt_id)
					// tidak perlu lagi diminta pilih UPT setiap cookie kedaluwarsa/sesi baru.
					const bebasPilihUpt = !!(data.access && data.access.bebas_pilih_upt);
					const uptIdTetap = data.pegawai[0].upt_id;

					if (data.pegawai[0].kabupaten_id != undefined) {
						if (Cookies.get(this.config.get_cookie_name() + "_upt") == undefined && data.pegawai[0].level_user == 3) {
							if (bebasPilihUpt && uptIdTetap) {
								this.autoPilihUpt(uptIdTetap, data.pegawai[0].is_notice);
							} else {
								this.setState({
									isModalUpt: true,
									modalUptStep: 2,
									isNotice: data.pegawai[0].is_notice
								}, () => {
									this.getUpt(data.pegawai[0].kabupaten_id);
									if (data.pegawai[0].is_notice==true) {
										Cookies.set(this.config.get_cookie_name() + "_isNotice", true, { expires: inOneHours })
									}
								})
							}
						}
					}

					if (Cookies.get(this.config.get_cookie_name() + "_upt") == undefined && data.pegawai[0].level_user == 2) {
						if (bebasPilihUpt && uptIdTetap) {
							this.autoPilihUpt(uptIdTetap, data.pegawai[0].is_notice);
						} else {
							this.setState({
								isModalUpt: true,
								modalUptStep: 1,
							}, () => {
								this.getKabupaten();
							});
						}
					}
					
					if (data.pegawai[0].is_notice != undefined) {
						if(Cookies.get(this.config.get_cookie_name() + "_isNotice"))
							this.setState({
								isNotice: data.pegawai[0].is_notice
							}, () => {
								if (data.pegawai[0].is_notice) {
									Cookies.set(this.config.get_cookie_name() + "_isNotice", true, { expires: inOneHours })
								}
							})
					}

					// Migrasi Legacy Notice: kalau UPT ini belum PERNAH punya BoxNotice
					// sama sekali dan pegawai punya kapabilitas migrasi (own-UPT/bebas
					// semua UPT - lihat migrasi_legacy_wajib di be/authentication/
					// serializer.py), modal ini tampil DULUAN dan GANTIKAN TOTAL modal
					// Pengaturan Notice manual di bawah (dua blok if berikutnya sengaja
					// diberi guard !migrasiLegacyWajib) - supaya UPT baru wajib lewat
					// jalur box (opname fisik + approval), bukan lagi counter manual.
					const migrasiLegacyWajib = !!(data.waktu_habis && data.waktu_habis.migrasi_legacy_wajib);
					const migrasiLegacyStatusAwal = data.waktu_habis ? data.waktu_habis.migrasi_legacy_status : null;

					if (Cookies.get(this.config.get_cookie_name() + "_upt") != undefined && data.pegawai[0].level_user == 3 && migrasiLegacyWajib) {
						this.setState({
							modalMigrasiLegacy: true,
							migrasiLegacyStatus: migrasiLegacyStatusAwal,
							migrasiKodeLegacy: '',
							migrasiAwalLegacy: undefined,
							migrasiAkhirLegacy: undefined,
						}, () => {
							if (migrasiLegacyStatusAwal === 'belum') {
								this.fetchSaranMigrasiLegacy();
							}
						});
					} else if (this.state.modalMigrasiLegacy) {
						// Sudah disetujui/tidak lagi wajib sejak modal ini terakhir
						// dibuka (mis. setelah klik "Cek Status") - tutup, biarkan dua
						// blok di bawah (kini tidak lagi diblokir !migrasiLegacyWajib)
						// yang menentukan modal Pengaturan Notice biasa perlu tampil
						// atau tidak.
						this.setState({ modalMigrasiLegacy: false, migrasiLegacyStatus: null });
					}

					if (Cookies.get(this.config.get_cookie_name() + "_upt") != undefined && data.pegawai[0].level_user == 3 && Cookies.get(this.config.get_cookie_name() + "_isNotice") && !migrasiLegacyWajib) {
						if (JSON.parse(Cookies.get(this.config.get_cookie_name() + "_isNotice")) == true && data.waktu_habis.tanggal_update_notice==true) {
							// console.log('tampil notice');
							this.setState({
								modalNotice: true
							}, () => {
								this.getNotice()
								this.fetchBoxList(data.pegawai[0].upt_id)
							});
						}

					}

					if (Cookies.get(this.config.get_cookie_name() + "_upt") != undefined && data.pegawai[0].level_user == 3 && data.waktu_habis.konfirmasi_kasi==true && !migrasiLegacyWajib){
						if (data.waktu_habis.is_bypass == false){
								this.setState({
								modalKonfirNotice: true,
							});
							// console.log('tampil blokir login');
						}
						if (data.waktu_habis.is_bypass == true){
							this.setState({
								modalNotice: true
							}, () => {
								this.getNotice()
								this.fetchBoxList(data.pegawai[0].upt_id)
							});
							console.log('tampil notice woi');
						}
					}
					
					// console.log('is notice', JSON.parse(Cookies.get(this.config.get_cookie_name() + "_isNotice")));
					// console.log('waktu_habis', data.waktu_habis.konfirmasi_kasi);

					if (data.waktu_habis.start_at != undefined) {
						this.props.setConfig({
							start_at: data.waktu_habis.start_at,
							timeout_at: data.waktu_habis.timeout_at,
						})

						setTimeout(() => {
							this.startCountDown();
						}, 200);
					}

					// askForPermissioToReceiveNotifications(data[0].tempatTugas);

					// if(!this.props.switchable){
					// 	// this.props.setConfig({
					// 	// 	isSuperadmin: data[0].is_superuser
					// 	// });
					// }
				}
				
			}).catch((response) => {
				const code = response && response.responseCode;
				if (code === 401 || code === 403) {
					// Sesi tidak valid — logout
					message.error({ content: 'Sesi tidak valid, silakan login ulang', key: 'toast' });
					this.props.setConfig({
						uptDipilih: "",
						isLogin: false,
						username: '',
						nama: '',
						id: '',
						pp: '',
						alamat: '',
						no_hp: '',
						layanan_id: [],
						layanan_str: [],
					});
				} else {
					// Network error / server down — jangan logout, hindari infinite loop
					message.error({ content: 'Gagal terhubung ke server, periksa koneksi backend', duration: 5, key: 'toast' });
				}
			});
	}

	async getNotice() {
		message.loading({ content: 'Menampilkan data notice...', duration: 0, key: 'toast' });

		this.props.ajaxViewHandler('get', configClass.apiUrl.notice)
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					if (data.results.length > 0) {
						this.formRef.current.setFieldsValue(data.results[0]);
						this.setState({
							aksi: 'edit',
							method: 'put',
							idLama: data.results[0].id + '/'
						});
					} else {
						this.setState({
							aksi: 'tambah',
							method: 'post',
							idLama: ""
						});
					}
					message.destroy();
				} else {
					const errTitle = 'error preview data lama';
					this.setState({
						errTitle: errTitle,
						errMsg: this.props.responseMsg
					});
					message.error({ content: errTitle, duration: 2, key: 'toast' });
				}
			}).catch((response) => {
				console.log('gagal_get_preview', response);
				message.error({ content: 'gagal request data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	// Dikunci kalau UPT ini SEDANG punya box 'aktif' - counter sepenuhnya
	// dikendalikan otomatis oleh sistem Gudang Notice di kondisi itu (rebase
	// saat box diaktifkan, increment saat pembayaran), edit manual cuma bisa
	// bikin sisa stok/penerbitan notice tidak sesuai (lihat insiden UPT
	// Palangka Raya). Sama seperti di fe/src/views/notice/Notice.jsx.
	_hasBoxAktif = () => this.state.listBox.some((b) => b.status === 'aktif');

	// Box notice UPT sendiri, ditampilkan di samping form modal Pengaturan
	// Notice yang muncul otomatis setelah login. BoxNoticeViewset menerima
	// filter upt_id eksplisit di semua tingkat izin (lihat
	// be/gudangnotice/views.py) jadi selalu kembali box milik UPT ini saja.
	// uptId WAJIB dikirim eksplisit dari pemanggil di getProfile() (bukan
	// dibaca dari this.props.upt_id) - setConfig() yang baru saja dispatch
	// di atas belum tentu sudah tercermin di this.props pada eksekusi
	// sinkron yang sama (closure props masih snapshot lama sampai re-render).
	fetchBoxList = (uptId) => {
		const upt = uptId || this.props.upt_id;
		if (!upt) return;
		this.setState({ loadingBoxList: true });
		this.props.ajaxViewHandler('get', `${configClass.apiUrl.box}?upt_id=${upt}&limit=50`)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					const list = Array.isArray(data) ? data : (data.results || []);
					this.setState({ listBox: list });
				}
				this.setState({ loadingBoxList: false });
			}).catch(() => this.setState({ loadingBoxList: false }));
	};

	// Saran rentang box (pembulatan kelipatan 1000 dari nomor terakhir
	// legacy) - endpoint sama dipakai halaman DataMigrasiLegacyNotice.jsx,
	// own_access otomatis membatasi hasil ke UPT sendiri saja jadi cukup
	// ambil elemen pertama. Kalau kosong (mis. sudah keburu dimigrasi
	// UPT lain sejak getProfile), form tetap tampil kosong tanpa saran.
	fetchSaranMigrasiLegacy = () => {
		this.setState({ loadingSaranMigrasiLegacy: true });
		this.props.ajaxViewHandler('get', configClass.apiUrl.legacyPending)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					const list = Array.isArray(data) ? data : [];
					const saran = list.find((r) => r.upt_id === this.props.upt_id) || list[0] || null;
					this.setState({
						migrasiLegacySaran: saran,
						migrasiAwalLegacy: saran ? saran.saran_nomor_awal : undefined,
						migrasiAkhirLegacy: saran ? saran.saran_nomor_akhir : undefined,
					});
				}
				this.setState({ loadingSaranMigrasiLegacy: false });
			}).catch(() => this.setState({ loadingSaranMigrasiLegacy: false }));
	};

	handleSubmitMigrasiLegacy = () => {
		const { migrasiKodeLegacy, migrasiAwalLegacy, migrasiAkhirLegacy } = this.state;
		if (!migrasiKodeLegacy || !migrasiKodeLegacy.trim()) {
			message.warning({ content: 'Kode notice baru wajib diisi.', duration: 2, key: 'toast' });
			return;
		}
		if (!migrasiAwalLegacy || !migrasiAkhirLegacy || Number(migrasiAkhirLegacy) < Number(migrasiAwalLegacy)) {
			message.warning({ content: 'Rentang nomor tidak valid.', duration: 2, key: 'toast' });
			return;
		}
		this.setState({ loadingSubmitMigrasiLegacy: true, errTitleMigrasiLegacy: '', errMsgMigrasiLegacy: '' });
		this.props.ajaxHandler('post', configClass.apiUrl.migrasiLegacy, {
			upt_id: this.props.upt_id,
			kode_notice: migrasiKodeLegacy.trim(),
			nomor_awal: migrasiAwalLegacy,
			nomor_akhir: migrasiAkhirLegacy,
		}, false, true)
			.then(() => {
				if (this.props.isSuccess) {
					message.success({
						content: 'Pengajuan migrasi terkirim, menunggu persetujuan dari Kantor Induk sebelum box benar-benar aktif.',
						duration: 3, key: 'toast',
					});
					this.setState({ migrasiLegacyStatus: 'pending' });
				} else {
					const msg = this.props.responseMsg;
					this.setState({
						errTitleMigrasiLegacy: 'Gagal Mengajukan Migrasi',
						errMsgMigrasiLegacy: (typeof msg === 'string' ? msg : (msg && msg.error)) || 'Gagal mengajukan migrasi legacy.',
					});
				}
				this.setState({ loadingSubmitMigrasiLegacy: false });
			}).catch(() => {
				this.setState({
					loadingSubmitMigrasiLegacy: false,
					errTitleMigrasiLegacy: 'Gagal Mengirim',
					errMsgMigrasiLegacy: 'Gagal mengirim, coba lagi.',
				});
			});
	};

	// Cek ulang status persetujuan tanpa reload penuh - dipanggil dari
	// tombol "Cek Status" saat modal dalam kondisi 'pending' (blokir total
	// sesuai keputusan produk: tidak ada tombol lewati/tutup di kondisi ini).
	handleRefreshMigrasiLegacy = () => {
		this.setState({ loadingRefreshMigrasiLegacy: true });
		this.getProfile();
		setTimeout(() => this.setState({ loadingRefreshMigrasiLegacy: false }), 600);
	};

	handleSubmitNotice = (values) => {
		var datas = values;
		this.postDataNotice(datas);
	}

	async postDataNotice(datas) {
		this.setState({
			errMsg: ''
		})
		message.loading({ content: 'Memproses...', key: 'toast' });

		this.props.ajaxHandler(this.state.method, configClass.apiUrl.notice + this.state.idLama, datas, false, true)
			.then(() => {
				this.setState({
					loadingButton: false
				});
				if (this.props.isSuccess) {
					message.success({ content: 'berhasil menyimpan data', duration: 2, key: 'toast' });
					Cookies.set(this.config.get_cookie_name() + "_isNotice", false, { expires: inOneHours })
					this.setState({
						modalNotice: false,
						modalKonfirNotice: false,
						isNotice: false,
						is_notice: false
					});
				} else {
					const errTitle = 'gagal menyimpan data'
					message.error({ content: errTitle, duration: 2, key: 'toast' });
					this.setState({
						errTitle: errTitle,
						errMsg: this.props.responseMsg
					});
				}
			}).catch((response) => {
				console.log('gagal_post', response);
				this.setState({
					loadingButton: false
				});
				message.error({ content: 'kesalahan pengiriman data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	startCountDown() {
		if (Cookies.get(this.config.get_cookie_name() + "_upt") != undefined) {
			if (this.props.start_at != null) {
				if (moment(this.props.start_at) > moment()) {
					var now = moment();
					this.props.setConfig({
						jam_countdown: "Buka " + moment(this.props.start_at).startOf('minutes').fromNow() + " lagi"
					})

					setTimeout(() => {
						this.startCountDown();
					}, 1000);

				} else {
					var now = moment();
					let jenis = "Buka";
					let countDownMnt = parseInt((moment.duration(now.diff(this.props.timeout_at))).asMinutes());
					let countDownScd = parseInt((moment.duration(now.diff(this.props.timeout_at))).asSeconds() % 60);

					if (parseInt((moment.duration(now.diff(this.props.timeout_at))).asMinutes()) < 0) {
						if (countDownScd < 0) {
							jenis = "Buka";
							countDownMnt = countDownMnt * -1;
							countDownScd = countDownScd * -1;
						} else {
							jenis = "Buka";
							countDownMnt = countDownMnt * -1;
							countDownScd = countDownScd * -1;
						}
					} else {
						if (countDownScd < 0) {
							jenis = "Buka";
							countDownMnt = countDownMnt * -1;
							countDownScd = countDownScd * -1;
						} else {
							jenis = "Tutup";
							countDownMnt = countDownMnt * -1;
							countDownScd = countDownMnt == 0 ? countDownScd : countDownScd * -1;
						}

						//jenis = "Tutup";
					}

					const hours = Math.floor(countDownMnt / (60));
					const minutes = Math.floor((countDownMnt % 60));
					const seconds = Math.floor((countDownMnt % (1000 * 60)) / 1000);

					// console.log(minutes);
					this.props.setConfig({
						// jam_countdown: moment(this.props.timeout_at).startOf('minutes').fromNow(),
						// jam_countdown: jenis == "Buka" ? "Tutup dalam = " + countDownMnt + ":" + countDownScd : "Tutup",
						jam_countdown: jenis == "Buka" ? "Tutup " + hours + " Jam "+ minutes + " Menit : " + countDownScd + " detik Lagi" : "Tutup",
						tutup_countdown: parseInt((moment.duration(now.diff(this.props.timeout_at))).asMinutes()),
					})

					//alert((moment.duration(now.diff(this.props.timeout_at))).asMinutes())

					setTimeout(() => {
						this.startCountDown();
					}, 1000);
				}

			}
		}
	}

	async getUpt(kab_id) {
		this.setState({
			loadingUpt: true
		});
		this.props.ajaxViewHandler('get', configClass.apiUrl.upt + "?kabupaten=" + kab_id + "&limit=100")
			.then(() => {
				const data = this.props.responseMsg;
				// console.log('data_profile', data);
				if (data != undefined) {
					this.setState({
						listUpt: data.results
					})
				}
				this.setState({
					loadingUpt: false
				});
			}).catch((response) => {
				console.log('gagal_upt', response);
				message.error({ content: 'gagal request data upt, coba lagi', key: 'toast' });
				this.setState({
					loadingUpt: false
				});
			});
	}

	async getKabupaten() {
		this.setState({ loadingKabupaten: true });
		this.props.ajaxViewHandler('get', configClass.apiUrl.kabupaten + '?limit=200')
			.then(() => {
				const data = this.props.responseMsg;
				if (data) {
					this.setState({ listKabupaten: data.results || data });
				}
				this.setState({ loadingKabupaten: false });
			}).catch(() => {
				message.error({ content: 'gagal memuat data kabupaten', key: 'toast' });
				this.setState({ loadingKabupaten: false });
			});
	}

	handlePilihKabupaten(kabupaten) {
		this.setState({
			selectedKabupaten: kabupaten,
			modalUptStep: 2,
			listUpt: [],
			loadingUpt: true,
		}, () => {
			this.getUpt(kabupaten.id);
		});
	}

	pilihUpt(item, silent = false) {
		Cookies.set(this.config.get_cookie_name() + "_upt", item, { expires: inOneHours })
		this.setState({
			isModalUpt: false
		})
		this.props.setConfig({
			uptDipilih: JSON.stringify(item)
		});
		// this.connectWebSocket();

		this.getProfile();

		if (!silent) {
			message.success({ content: 'berhasil memilih upt', key: 'toast' });
		}

		// if (isBypass == true && this.props.waktu_akses.konfirmasi_kasi==true) {
		// 	this.setState({
		// 		modalNotice: true
		// 	}, () => {
		// 		this.getNotice()
		// 	})
		// }

		// if (this.props.waktu_akses.konfirmasi_kasi==true) {
		// 	this.setState({
		// 		modalKonfirNotice: true,
		// 	})
		// }
	}

	// Untuk jabatan dengan bebas_pilih_upt: pegawai sudah punya UPT tetap
	// (upt_id), jadi langsung pakai itu tanpa menampilkan modal pilih UPT.
	async autoPilihUpt(uptId, isNotice) {
		this.props.ajaxViewHandler('get', `${configClass.apiUrl.upt}${uptId}/`)
			.then(() => {
				const upt = this.props.responseMsg;
				if (this.props.isSuccess && upt && upt.id) {
					if (isNotice == true) {
						Cookies.set(this.config.get_cookie_name() + "_isNotice", true, { expires: inOneHours })
					}
					this.pilihUpt(upt, true);
				}
			})
			.catch(() => {});
	}

	async handlePilihUpt(upt) {
		this.setState({
			loadingPilihUpt: true,
			errPilihUpt: null,
		});
		this.props.ajaxViewHandler('post', configClass.apiUrl.pegawai, JSON.stringify({ upt: upt.id }), false, true)
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					this.pilihUpt(upt)
					// localStorage.setItem("isbypass", this.props.waktu_akses.is_bypass);
				} else {
					this.setState({
						errPilihUpt: JSON.stringify(data)
					});

				}

				this.setState({
					loadingPilihUpt: false
				})

			}).catch((response) => {
				console.log('gagal_plhupt', response);
				message.error({ content: 'gagal pilih data upt, coba lagi', key: 'toast' });
				this.setState({
					loadingPilihUpt: false
				})
			});
	}

	render() {
		if (!this.props.isLogin) {
			return <Redirect to="/auth" />
		}
		if (this.state.isForbidden) {
			return <Redirect to="/admin/forbidden" />
		}
		return (
			<>
			<Layout>
				{!this.props.isMobile && <Sider />}
				<div className="container" style={{ maxWidth: '4000px' }}>
					<Header />
					{this.props.akses == null
						?
						<Content className="content">
							{/* Skeleton loading — menyerupai struktur halaman nyata */}
							<div style={{ padding: '4px 0' }}>
								<div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
									<Skeleton.Avatar active shape="square" size={36} style={{ borderRadius: 8 }} />
									<div>
										<Skeleton.Input active style={{ width: 200, height: 18, borderRadius: 6, display: 'block', marginBottom: 6 }} />
										<Skeleton.Input active style={{ width: 120, height: 13, borderRadius: 5 }} />
									</div>
								</div>
								<SkeletonTable rows={8} columns={5} />
							</div>
						</Content>
						:
						<Content
							className="content"
							style={this.props.isMobile ? { paddingBottom: 80 } : {}}
						>
							<Switch>
								<Route path="/admin" component={Home} exact />
								<Route path="/admin/forbidden" component={Forbidden} exact />
								<Route path="/admin/index" component={Home} />
								<Route path="/admin/profil" component={FormProfil} exact />

								<LayananRoute isAkses={this.props.akses.master_negara} path="/admin/negara" exact component={DataNegara} />

								<LayananRoute isAkses={this.props.akses.master_Tipe} path="/admin/tipe" exact component={DataTipe} />
								<LayananRoute isAkses={this.props.akses.master_Tipe} path="/admin/tipe/form/:id?" exact component={FormTipe} />

								<LayananRoute isAkses={this.props.akses.master_merek} path="/admin/merek" exact component={DataMerek} />
								<LayananRoute isAkses={this.props.akses.master_kendaraan} path="/admin/kendaraan" exact component={DataKendaraan} />
								<LayananRoute isAkses={this.props.akses.master_kendaraan && (this.props.level_user === 1 || this.props.level_user === 2)} path="/admin/kendaraan/form/:id" exact component={FormKendaraan} />
								<LayananRoute isAkses={this.props.akses.master_kendaraan_tambah_manual} path="/admin/kendaraan/tambah-manual" exact component={FormTambahKendaraan} />

								<LayananRoute isAkses={this.props.akses.master_jenis_kendaraan} path="/admin/jenis-kendaraan" exact component={DataJenisKendaraan} />
								<LayananRoute isAkses={this.props.akses.master_jenis_kendaraan} path="/admin/jenis-kendaraan/form/:id?" exact component={FormJenisKendaraan} />

								<LayananRoute isAkses={this.props.akses.master_bahan_bakar} path="/admin/bahan-bakar" exact component={DataBahanBakar} />

								<LayananRoute isAkses={this.props.akses.master_warna} path="/admin/warna" exact component={DataWarna} />

								<LayananRoute isAkses={this.props.akses.master_pekerjaan} path="/admin/pekerjaan" exact component={DataPekerjaan} />
								<LayananRoute isAkses={this.props.akses.master_pekerjaan} path="/admin/pekerjaan/form/:id?" exact component={FormPekerjaan} />

								<LayananRoute isAkses={this.props.akses.master_kepemilikan} path="/admin/kepemilikan" exact component={DataKepemilikan} />
								<LayananRoute isAkses={this.props.akses.master_kepemilikan} path="/admin/kepemilikan/form/:id?" exact component={FormKepemilikan} />

								<LayananRoute isAkses={this.props.akses.master_layanan} path="/admin/layanan" exact component={DataLayanan} />
								<LayananRoute isAkses={this.props.akses.master_layanan} path="/admin/layanan/form/:id?" exact component={FormLayanan} />
								<LayananRoute isAkses={this.props.akses.master_gudang_notice} path="/admin/gudang-notice" exact component={DataGudangNotice} />
								<LayananRoute isAkses={this.props.akses.master_mac_address} path="/admin/mac-address" exact component={DataMacAddress} />

								<LayananRoute isAkses={this.props.akses.master_dealer} path="/admin/dealer" exact component={DataDealer} />
								<LayananRoute isAkses={this.props.akses.master_dealer} path="/admin/dealer/form/:id?" exact component={FormDealer} />

								<LayananRoute isAkses={this.props.akses.master_payment} path="/admin/payment" exact component={DataPayment} />

								<LayananRoute isAkses={this.props.akses.master_golongan} path="/admin/golongan" exact component={DataGolongan} />

								<LayananRoute isAkses={this.props.akses.master_iwkbu} path="/admin/iwkbu" exact component={DataIwkbu} />

								{/* Khusus Superadmin (level_user === 1) - tidak ikut pola hak_akses biasa karena data rekening kabupaten sensitif */}
								<LayananRoute isAkses={this.props.level_user === 1} path="/admin/kabupaten" exact component={DataKabupaten} />

								<LayananRoute isAkses={this.props.akses.master_warna_plat} path="/admin/warna-plat" exact component={DataWarnaPlat} />

								<LayananRoute isAkses={this.props.akses.master_fungsi} path="/admin/fungsi" exact component={DataFungsi} />

								{/* <LayananRoute isAkses={this.props.akses.transaksi_pendaftaran} path="/admin/transaksi/pendaftaran" exact render={(props) => <FormPendaftaran {...props} />} /> */}
								<LayananRoute isAkses={this.props.akses.transaksi_pendaftaran} path="/admin/transaksi/pendaftaran" exact component={FormPendaftaran} />
								<LayananRoute isAkses={this.props.waktu_akses.is_bypass == false && this.props.akses.transaksi_pendaftaran_eri} path="/admin/transaksi/pendaftaran-eri" exact component={FormPendaftaranEri} />
								{/* <LayananRoute isAkses={this.props.waktu_akses.is_bypass || this.props.akses.transaksi_pembayaran} path="/admin/transaksi/pembayaran" exact component={FormPembayaran} /> */}
								
								{/* <LayananRoute isAkses={this.props.akses.transaksi_penetapan} path="/admin/transaksi/penetapan-biaya" exact render={(props) => <FormPenetapanBiaya {...props} />} /> */}
								<LayananRoute isAkses={this.props.akses.transaksi_penetapan} path="/admin/transaksi/penetapan-biaya" exact component={FormPenetapanBiaya} />
								<LayananRoute isAkses={this.props.akses.transaksi_penetapan_eri} path="/admin/transaksi/penetapan-biaya-eri" exact component={FormPenetapanBiayaEri} />
								{/* <LayananRoute isAkses={this.props.akses.iwkbu} path="/admin/transaksi/iwkbu" exact render={(props) => <FormIwkbu {...props} />} /> */}
								<LayananRoute isAkses={this.props.akses.iwkbu} path="/admin/transaksi/iwkbu" exact component={FormIwkbu} />
								<LayananRoute isAkses={this.props.akses.blokir} path="/admin/transaksi/blokir" exact component={FormBlokir} />

								<LayananRoute isAkses={this.props.akses.informasi_informasi_kendaraan} path="/admin/informasi/informasi-kendaraan" exact component={FormInformasiKendaraan} />
								<LayananRoute isAkses={this.props.akses.informasi_cari_kendaraan} path="/admin/informasi/cari-kendaraan" exact component={FormCariKendaraan} />
								<LayananRoute isAkses={this.props.akses.informasi_informasi_kendaraan} path="/admin/transaksi/informasi-penetapan-biaya" exact component={FormInformasiPenetapan} />

								<LayananRoute isAkses={this.props.akses.pengaturan_umum} path="/admin/pengaturan/umum" exact component={Umum} />

								<LayananRoute isAkses={this.props.akses.pengaturan_dikon} path="/admin/pengaturan/diskon" exact component={DataDiskon} />
								<LayananRoute isAkses={this.props.akses.pengaturan_dikon} path="/admin/pengaturan/diskon/form/:id?" exact component={FormDiskon} />
								<LayananRoute isAkses={this.props.akses.pengaturan_reward_diskon} path="/admin/pengaturan/reward-tepat-waktu" exact component={DataRewardDiskon} />
								<LayananRoute isAkses={this.props.akses.pengaturan_reward_diskon} path="/admin/pengaturan/reward-tepat-waktu/form/:id?" exact component={FormRewardDiskon} />
								<LayananRoute isAkses={this.props.akses.pengaturan_hari_libur} path="/admin/pengaturan/hari-libur" exact component={DataHariLibur} />
								<LayananRoute isAkses={this.props.akses.pengaturan_migrasi_legacy_notice} path="/admin/pengaturan/migrasi-legacy-notice" exact component={DataMigrasiLegacyNotice} />

								{/* Pengaturan Secrets (Fase 9) - API Key PINDAH dari /admin/pengaturan/apikey */}
								<LayananRoute isAkses={this.props.akses.secrets_apikey} path="/admin/secrets/apikey" exact component={DataApiKey} />
								<LayananRoute isAkses={this.props.akses.secrets_print_client_config} path="/admin/secrets/konfigurasi-app-cetak" exact component={FormPrintClientConfig} />

								<LayananRoute isAkses={this.props.akses.pengaturan_njkb} path="/admin/njkb" exact component={DataNjkb} />
								<LayananRoute isAkses={this.props.akses.pengaturan_njkb} path="/admin/njkb/form/:id?" exact component={FormNjkb} />
								<LayananRoute isAkses={this.props.akses.pengaturan_njkb} path="/admin/njkb-import" exact component={DataImportNjkb} />

								<LayananRoute isAkses={this.props.akses.pengaturan_swdkllj} path="/admin/pengaturan/swdkllj" exact component={DataSwdkllj} />
								<LayananRoute isAkses={this.props.akses.pengaturan_swdkllj} path="/admin/pengaturan/swdkllj/form/:id?" exact component={FormSwdkllj} />

								<LayananRoute isAkses={this.props.akses.pengaturan_adm_stnk} path="/admin/pengaturan/admstnk" exact component={DataAdmstnk} />
								<LayananRoute isAkses={this.props.akses.pengaturan_adm_stnk} path="/admin/pengaturan/admstnk/form/:id?" exact component={FormAdmstnk} />

								<LayananRoute isAkses={this.props.akses.pengaturan_adm_tnkb} path="/admin/pengaturan/admtnkb" exact component={DataAdmtnkb} />
								<LayananRoute isAkses={this.props.akses.pengaturan_adm_tnkb} path="/admin/pengaturan/admtnkb/form/:id?" exact component={FormAdmtnkb} />

								<LayananRoute isAkses={this.props.akses.pengaturan_denda_pkb} path="/admin/pengaturan/denda-pkb" exact component={DataDendaPkb} />
								<LayananRoute isAkses={this.props.akses.pengaturan_denda_pkb} path="/admin/pengaturan/denda-pkb/form/:id?" exact component={FormDendaPkb} />

								<LayananRoute isAkses={this.props.akses.pengaturan_denda_swdkllj} path="/admin/pengaturan/denda-swdkllj" exact component={DataDendaSwdkllj} />
								<LayananRoute isAkses={this.props.akses.pengaturan_denda_swdkllj} path="/admin/pengaturan/denda-swdkllj/form/:id?" exact component={FormDendaSwdkllj} />

								<LayananRoute isAkses={this.props.waktu_akses.is_bypass || this.props.akses.pengaturan_notice} path="/admin/pengaturan/notice" exact component={Notice} />

								<LayananRoute isAkses={this.props.waktu_akses.is_bypass || this.props.akses.transaksi_pembayaran} path="/admin/transaksi/pembayaran" exact component={FormPembayaran} />
								<LayananRoute isAkses={this.props.akses.transaksi_surat_keterangan_fiskal} path="/admin/transaksi/surat-keterangan-fiskal" exact component={SuratKeteranganFiskal} />

								<LayananRoute isAkses={this.props.akses.master_tanda_tangan} path="/admin/tanda_tangan" exact component={DataTandaTangan} />

								<LayananRoute isAkses={this.props.akses.master_ttd_laporan} path="/admin/tanda_tangan_laporan" exact component={DataTandaTanganLaporan} />
								<LayananRoute isAkses={this.props.akses.master_ttd_laporan} path="/admin/tanda_tangan_laporan/form" exact component={FormTandaTanganLaporan} />

								<LayananRoute isAkses={this.props.akses.laporan} path="/admin/laporan" exact component={Laporan} />

								<LayananRoute isAkses={this.props.akses.laporan_pnbp} path="/admin/laporan/pnbp" exact component={LaporanPnbp} />
								<LayananRoute isAkses={this.props.akses.laporan_penerimaan_bbnkb_pkb} path="/admin/laporan/bbnkb-pkb" exact component={BbnkbDanPkb} />
								<Route path="/admin/laporan/rekapitulasi-penerimaan" exact component={RekapitulasiPenerimaan} />
								<LayananRoute isAkses={this.props.akses.laporan_notice} path="/admin/laporan/notice" exact component={LapNotice} />
								<LayananRoute isAkses={this.props.akses.laporan_notice_rusak} path="/admin/laporan/notice-rusak" exact component={LapNoticeRusak} />
								<LayananRoute isAkses={this.props.akses.laporan_penggunaan_notice_rusak} path="/admin/laporan/penggunaan-notice-rusak" exact component={LapPenggunaanNoticeRusak} />
								<LayananRoute isAkses={this.props.akses.laporan_overlap_notice} path="/admin/laporan/overlap-notice" exact component={LapOverlapNotice} />
								<LayananRoute isAkses={this.props.akses.laporan_duplikat_nopol_aktif} path="/admin/laporan/duplikat-nopol-aktif" exact component={LapDuplikatNopolAktif} />
								<LayananRoute isAkses={this.props.akses.laporan_audit_nik} path="/admin/laporan/audit-nik" exact component={LapAuditNik} />
								<LayananRoute isAkses={this.props.level_user === 1 || this.props.akses.laporan_ba_batal_skpd} path="/admin/laporan/ba-batal-skpd" exact component={LapBaBatalSkpd} />
								<LayananRoute isAkses={this.props.akses.laporan_status_printer} path="/admin/laporan/status-printer" exact component={StatusPrinter} />

								<LayananRoute isAkses={this.props.akses.laporan_swdkllj} path="/admin/laporan/swdkllj" exact component={LapSwdkllj} />

								<LayananRoute isAkses={this.props.akses.laporan_kasir} path="/admin/laporan/kasir" exact component={LapKasir} />
								<LayananRoute isAkses={this.props.akses.laporan_teller} path="/admin/laporan/teller" exact component={LapTeller} />
								
								<LayananRoute isAkses={this.props.akses.laporan_perekening} path="/admin/laporan/perekening" exact component={LapPerRekening} />

								<LayananRoute isAkses={this.props.akses.laporan_cetak_stnk} path="/admin/laporan/cetak-stnk" exact component={LapCetakStnk} />

								<LayananRoute isAkses={this.props.akses.laporan_bendahara_penerimaan} path="/admin/laporan/bendahara-penerimaan" exact component={LapBendaharaPenerimaan} />

								<LayananRoute isAkses={this.props.akses.laporan_penetapan_pkb_bbnkb} path="/admin/laporan/harian-pkb" exact component={LapPenetapanPkb} />
								
								<LayananRoute isAkses={this.props.akses.laporan_sum32} path="/admin/laporan/sum-32" exact component={LapSUM32} />

								<LayananRoute isAkses={this.props.akses.laporan_penerimaan_pkb_plat} path="/admin/laporan/penerimaan-pkb-warna" exact component={LapPenerimaanPkbWarnaPlat} />

								<LayananRoute isAkses={this.props.akses.laporan_bendaraha_pkb_bbnkb} path="/admin/laporan/bendahara-pkb" exact component={LapRealisasiPenerimaan} />

								<LayananRoute isAkses={this.props.akses.laporan_sts} path="/admin/laporan/stss" exact component={LapStss} />

								<LayananRoute isAkses={this.props.akses.laporan_sts} path="/admin/laporan/sts-harian" exact component={StsHarian} />

								<LayananRoute isAkses={this.props.akses.laporan_pemutihan} path="/admin/laporan/pemutihan" exact component={Pemutihan} />

								<LayananRoute isAkses={this.props.akses.analitik_proyeksi_potensi_pkb} path="/admin/analitik/proyeksi-potensi-pkb" exact component={AnalisaPotensiPkb} />
								<LayananRoute isAkses={this.props.akses.analitik_tunggakan} path="/admin/analitik/tunggakan" exact component={TunggakanKendaraan} />
								<LayananRoute isAkses={this.props.akses.analitik_list_tunggakan} path="/admin/analitik/list-tunggakan" exact component={ListTunggakanKendaraan} />

								<LayananRoute isAkses={this.props.akses.transaksi_cancle_notice} path="/admin/transaksi/cancel-notice" exact component={CancelNotice} />
								<LayananRoute isAkses={this.props.akses.transaksi_histori_notice} path="/admin/transaksi/histori-notice" exact component={HistoriNotice} />
								<LayananRoute isAkses={this.props.akses.transaksi_validasi_setoran} path="/admin/transaksi/validasi-setoran" exact component={ValidasiSetoran} />

								<LayananRoute isAkses={this.props.akses.pegawai_jabatan} path="/admin/jabatan" exact component={DataJabatan} />
								<LayananRoute isAkses={this.props.akses.pegawai_jabatan} path="/admin/jabatan/form/:id?" exact component={FormJabatan} />

								<LayananRoute isAkses={this.props.akses.pegawai_upt} path="/admin/upt" exact component={DataUpt} />
								<LayananRoute isAkses={this.props.akses.pegawai_upt} path="/admin/upt/form/:id?" exact component={FormUpt} />

								<LayananRoute isAkses={this.props.akses.pegawai_bidang} path="/admin/bidang" exact component={DataBidang} />
								<LayananRoute isAkses={this.props.akses.pegawai_bidang} path="/admin/bidang/form/:id?" exact component={FormBidang} />

								<LayananRoute isAkses={this.props.akses.pegawai_pegawai} path="/admin/pegawai" exact component={DataPegawai} />
								<LayananRoute isAkses={this.props.akses.pegawai_pegawai} path="/admin/pegawai/form/:id?" exact component={FormPegawai} />

								<LayananRoute isAkses={this.props.akses.pengaturan_printer} path="/admin/pengaturan/printer" exact component={DataPengaturanPrinter} />
								<LayananRoute isAkses={this.props.akses.pengaturan_printer} path="/admin/pengaturan/printer/form/:id?" exact component={FormPengaturanPrinter} />

								<LayananRoute isAkses={this.props.akses != null ? this.props.akses.pengaturan_target_pendapatan : null} path="/admin/pengaturan/target-pendapatan" exact component={DataTargetPendapatan} />
								<LayananRoute isAkses={this.props.akses != null ? this.props.akses.pengaturan_target_pendapatan : null} path="/admin/pengaturan/target-pendapatan/form/:id?" exact component={FormTargetPendapatan} />

								<LayananRoute isAkses={this.props.akses.informasi_migrasi} path="/admin/informasi/migrasi" exact component={DataMigrasi} />

								<LayananRoute isAkses={this.props.akses.transaksi_jasa_raharja} path="/admin/transaksi/jasaraharja" exact component={DataJasaraharja} />
								<LayananRoute isAkses={this.props.akses.transaksi_smdd} path="/admin/transaksi/smdd" exact component={DataSmdd} />
								<LayananRoute isAkses={this.props.akses.transaksi_koreksi_nomor_notice} path="/admin/transaksi/koreksi-nomor-notice" exact component={DataKoreksiNomorNotice} />
								<LayananRoute isAkses={this.props.akses.transaksi_sinkron_notice} path="/admin/transaksi/sinkron-notice" exact component={SinkronNotice} />
								<LayananRoute isAkses={this.props.akses.transaksi_audit_notice_rusak} path="/admin/transaksi/audit-notice-rusak" exact component={AuditNoticeRusak} />
								<LayananRoute isAkses={this.props.akses.jasa_raharja_resend} path="/admin/jasa-raharja/resend" exact component={ResendJasaRaharja} />
								<LayananRoute isAkses={this.props.akses.cross_check} path="/admin/transaksi/uji-silang" exact component={UjiSilangSWD} />
								

								<LayananRoute isAkses={this.props.akses.waktu_operasional} path="/admin/waktu-operasional" exact component={DataWaktuOperasional} />
								<LayananRoute isAkses={this.props.akses.waktu_operasional} path="/admin/waktu-operasional/form/:id?" exact component={FormWaktuOperasional} />

								{/* Panduan Pengguna - tampil bisa dibaca SEMUA orang yang login (plain Route,
								    bukan LayananRoute), edit digerbang hak_akses pengaturan_dokumentasi */}
								<Route path="/admin/panduan" exact component={DataPanduan} />
								<LayananRoute isAkses={this.props.akses.pengaturan_dokumentasi} path="/admin/panduan/edit" exact component={FormPanduan} />

								{/* Log Aktivitas Saya - self-service, bisa dibaca SEMUA orang yang
								    login (plain Route, sama pola dgn Panduan Pengguna di atas).
								    Log Aktivitas User (admin) - khusus level_user<=2, SAMA persis
								    pengecekan yang dipakai backend IsAdminOrSuperadmin - lihat
								    diskusi rencana 2026-10-16. */}
								<Route path="/admin/activitylog/saya" exact component={LogAktivitasSaya} />
								<LayananRoute isAkses={(this.props.level_user || 3) <= 2} path="/admin/activitylog/kelola" exact component={LogAktivitasAdmin} />

								<Route path="" render={() => <Page404 />} />
							</Switch>
						</Content>
					}

					{/*<Footer />*/}
				</div>
				<Modal
					title="Akses Terbatas"
					visible={this.state.isModalForbidden}
					footer={[]}
					closable={false}
					width={"50%"}
				>
					<div
						style={{
							textAlign: "center",
							fontSize: 24
						}}
					>
						Akses Terbatas, Halaman ini akan ditutup dalam
						<br />
						<div style={{ color: "red" }}>
							{this.state.counter}
						</div>
					</div>
				</Modal>
				<Modal
					visible={this.state.isModalUpt}
					footer={null}
					closable={false}
					centered
					width={'90vw'}
					style={{ maxWidth: 1200 }}
					bodyStyle={{ padding: 0 }}
					className="modal-pilih-upt"
				>
					{/* Header */}
					<div className="upt-modal-header">
						<div className="upt-modal-icon">
							{this.state.modalUptStep === 1 ? <EnvironmentOutlined /> : <BankOutlined />}
						</div>
						<div style={{ flex: 1 }}>
							<div className="upt-modal-title">
								{this.state.modalUptStep === 1 ? 'Pilih Kabupaten/Kota' : 'Pilih UPT'}
							</div>
							<div className="upt-modal-subtitle">
								{this.state.modalUptStep === 1
									? 'Silakan pilih kabupaten/kota terlebih dahulu'
									: this.state.selectedKabupaten
										? `UPT di ${this.state.selectedKabupaten.name}`
										: 'Silakan pilih Unit Pelaksana Teknis untuk melanjutkan'}
							</div>
						</div>
						{this.state.modalUptStep === 2 && this.state.selectedKabupaten && (
							<Button
								size="small"
								icon={<ArrowLeftOutlined />}
								onClick={() => this.setState({ modalUptStep: 1, listUpt: [], selectedKabupaten: null })}
								style={{
									alignSelf: 'center',
									marginLeft: 8,
									flexShrink: 0,
									borderColor: 'rgba(255,255,255,0.5)',
									color: '#fff',
									background: 'transparent',
								}}
							>
								Kembali
							</Button>
						)}
					</div>

					{/* Body */}
					<div className="upt-modal-body">
						{/* Step 1: Pilih Kabupaten (admin) */}
						{this.state.modalUptStep === 1 && (
							<>
								{this.state.loadingKabupaten && (
									<div className="upt-modal-state">
										<Spin size="large" />
										<p>Memuat data kabupaten...</p>
									</div>
								)}
								{!this.state.loadingKabupaten && this.state.listKabupaten.length === 0 && (
									<div className="upt-modal-state">
										<WarningOutlined style={{ fontSize: 36, color: '#f59e0b' }} />
										<p>Tidak ada data kabupaten</p>
									</div>
								)}
								{!this.state.loadingKabupaten && this.state.listKabupaten.length > 0 && (
									<Row gutter={[12, 12]}>
										{this.state.listKabupaten.map((item, idx) => (
											<Col xs={24} sm={12} md={8} key={"kab" + idx}>
												<div
													className="upt-card"
													onClick={() => this.handlePilihKabupaten(item)}
												>
													<div className="upt-card-icon">
														<EnvironmentOutlined />
													</div>
													<div className="upt-card-info">
														<div className="upt-card-nama">{item.name}</div>
													</div>
													<CheckCircleFilled className="upt-card-check" />
												</div>
											</Col>
										))}
									</Row>
								)}
							</>
						)}

						{/* Step 2: Pilih UPT */}
						{this.state.modalUptStep === 2 && (
							<>
								{/* Loading */}
								{(this.state.loadingUpt || this.state.loadingPilihUpt) && (
									<div className="upt-modal-state">
										<Spin size="large" />
										<p>{this.state.loadingPilihUpt ? 'Memproses, mohon menunggu...' : 'Memuat data UPT...'}</p>
									</div>
								)}

								{/* Empty */}
								{!this.state.loadingUpt && this.state.listUpt.length === 0 && (
									<div className="upt-modal-state">
										<WarningOutlined style={{ fontSize: 36, color: '#f59e0b' }} />
										<p>Belum ada data UPT di kabupaten ini</p>
									</div>
								)}

								{/* Error */}
								{this.state.errPilihUpt && (
									<div className="upt-modal-state upt-modal-error">
										<WarningOutlined style={{ fontSize: 32, color: '#ef4444' }} />
										<p>Gagal memilih UPT</p>
										<span>{this.state.errPilihUpt}</span>
									</div>
								)}

								{/* UPT List */}
								{!this.state.loadingUpt && this.state.listUpt.length > 0 && (
									<Row gutter={[12, 12]}>
										{this.state.listUpt.map((item, idx) => {
											const formatJam = (t) => t ? t.slice(0, 5) : null;
											const bukaSejak = formatJam(item.mulai_dari);
											const tutupPukul = formatJam(item.sampai_dengan);
											const isOpen = item.is_buka_sekarang;
											const hariText = item.hari_nama && item.hari_nama.length > 0
												? item.hari_nama.join(', ')
												: null;
											return (
												<Col xs={24} sm={12} md={8} key={"upt" + idx}>
													<div
														className="upt-card"
														onClick={() => {
															if (this.state.loadingPilihUpt) return;
															Modal.confirm({
																title: 'Konfirmasi Pilihan UPT',
																content: (
																	<span>
																		Apakah Anda yakin ingin masuk sebagai{' '}
																		<strong>{item.nama}</strong>?
																	</span>
																),
																okText: 'Ya, Lanjutkan',
																cancelText: 'Tidak, Pilih Lagi',
																centered: true,
																onOk: () => this.handlePilihUpt(item),
															});
														}}
													>
														<div className="upt-card-icon">
															<BankOutlined />
														</div>
														<div className="upt-card-info">
															<div className="upt-card-nama">{item.nama}</div>
															{item.alamat && (
																<div className="upt-card-alamat">
																	<EnvironmentOutlined style={{ fontSize: 10, marginRight: 3 }} />
																	{item.alamat}
																</div>
															)}
															{(bukaSejak && tutupPukul) && (
																<div style={{ fontSize: 11, color: '#6b7280', marginTop: 4 }}>
																	🕐 {bukaSejak} – {tutupPukul}
																</div>
															)}
															{hariText && (
																<div style={{ fontSize: 10, color: '#9ca3af', marginTop: 2 }}>
																	📅 {hariText}
																</div>
															)}
															{isOpen !== null && isOpen !== undefined && (
																<div style={{ marginTop: 4 }}>
																	<span style={{
																		fontSize: 10,
																		fontWeight: 700,
																		padding: '2px 7px',
																		borderRadius: 4,
																		background: isOpen ? '#d1fae5' : '#fee2e2',
																		color: isOpen ? '#065f46' : '#991b1b',
																		letterSpacing: 0.5,
																	}}>
																		{isOpen ? '● BUKA' : '● TUTUP'}
																	</span>
																</div>
															)}
														</div>
														<CheckCircleFilled className="upt-card-check" />
													</div>
												</Col>
											);
										})}
									</Row>
								)}
							</>
						)}
					</div>
				</Modal>

				<Modal
					title={null}
					centered
					visible={this.state.modalLogout}
					footer={null}
					closable={false}
					width="min(92vw, 460px)"
					className="modal-peringatan"
				>
					<div className="peringatan-modal-header">
						<div className="peringatan-modal-icon">
							<WarningOutlined />
						</div>
						<div>
							<div className="peringatan-modal-title">Sesi Berakhir</div>
							<div className="peringatan-modal-subtitle">Login dari perangkat lain terdeteksi</div>
						</div>
					</div>
					<div className="peringatan-modal-body">
						{this.state.pesan_logout}
					</div>
					<div className="peringatan-modal-footer">
						<Button
							type="danger"
							key="btn-submit"
							onClick={() => this.clearCokies()}
							style={{ borderRadius: 8, fontWeight: 600 }}
						>
							<CloseCircleOutlined /> Oke
						</Button>
					</div>
				</Modal>

				<Modal
					title={null}
					centered
					visible={this.state.idleWarningVisible}
					footer={null}
					closable={false}
					width="min(92vw, 460px)"
					className="modal-peringatan"
				>
					<div className="peringatan-modal-header">
						<div className="peringatan-modal-icon">
							<ClockCircleOutlined />
						</div>
						<div>
							<div className="peringatan-modal-title">Sesi Akan Berakhir</div>
							<div className="peringatan-modal-subtitle">Tidak ada aktivitas terdeteksi</div>
						</div>
					</div>
					<div className="peringatan-modal-body">
						Sesi Anda akan berakhir otomatis dalam{' '}
						<strong>{this.state.idleWarningCountdown} detik</strong> karena tidak
						ada aktivitas. Klik tombol di bawah untuk tetap melanjutkan sesi.
					</div>
					<div className="peringatan-modal-footer">
						<Button
							type="primary"
							onClick={() => { this._lastActivityAt = Date.now(); this.resetIdleTimer(); }}
							style={{ borderRadius: 8, fontWeight: 600 }}
						>
							Saya Masih Di Sini
						</Button>
					</div>
				</Modal>

				<Modal
					title={null}
					centered
					visible={this.state.updateAvailable}
					footer={null}
					closable={!(this.state.updateMeta && this.state.updateMeta.force)}
					onCancel={() => this.setState({ updateAvailable: false })}
					maskClosable={false}
					width="min(92vw, 460px)"
					className="modal-peringatan"
				>
					<div className="peringatan-modal-header" style={{ background: 'linear-gradient(135deg, #0f2847, #1e4d8a)' }}>
						<div className="peringatan-modal-icon">
							<CloudDownloadOutlined />
						</div>
						<div>
							<div className="peringatan-modal-title">
								{this.state.updateMeta && this.state.updateMeta.force ? 'Pembaruan Wajib' : 'Versi Baru Tersedia'}
							</div>
							<div className="peringatan-modal-subtitle">
								Versi {this.state.updateMeta && this.state.updateMeta.release}
							</div>
						</div>
					</div>
					<div className="peringatan-modal-body">
						{this.renderUpdateMessage()}
					</div>
					<div className="peringatan-modal-footer">
						{!(this.state.updateMeta && this.state.updateMeta.force) && (
							<Button
								onClick={() => this.setState({ updateAvailable: false })}
								style={{ borderRadius: 8, fontWeight: 600, marginRight: 8 }}
							>
								Nanti
							</Button>
						)}
						<Button
							type="primary"
							onClick={() => window.location.reload()}
							style={{ borderRadius: 8, fontWeight: 600, background: '#0f2847', borderColor: '#0f2847' }}
						>
							<CloudDownloadOutlined /> Muat Ulang
						</Button>
					</div>
				</Modal>

				<Modal
					title={null}
					centered
					visible={this.state.modalKonfirNotice}
					footer={null}
					closable={false}
					onCancel={() => this.setState({ modalKonfirNotice: false })}
					width="min(92vw, 460px)"
					className="modal-peringatan"
				>
					<div className="peringatan-modal-header">
						<div className="peringatan-modal-icon">
							<WarningOutlined />
						</div>
						<div>
							<div className="peringatan-modal-title">Peringatan</div>
							<div className="peringatan-modal-subtitle">Nomor notice belum disetting</div>
						</div>
					</div>
					<div className="peringatan-modal-body">
						Nomor Notice belum disetting, Anda tidak memiliki akses untuk mengatur nomor notice.
						<br /><br />
						Hubungi Admin atau Kasi Penetapan untuk mengatur nomor notice.
					</div>
					<div className="peringatan-modal-footer">
						<Button
							type="danger"
							key="btn-submit"
							onClick={() => this.closeModal()}
							style={{ borderRadius: 8, fontWeight: 600 }}
						>
							<CloseCircleOutlined /> Oke
						</Button>
					</div>
				</Modal>

				<Modal
					visible={this.state.modalMigrasiLegacy}
					footer={null}
					closable={false}
					centered
					width="min(94vw, 560px)"
					bodyStyle={{ padding: 0 }}
					className="modal-notice"
				>
					<div className="notice-modal-header">
						<div className="notice-modal-icon">
							<BankOutlined />
						</div>
						<div>
							<div className="notice-modal-title">Migrasi Legacy Notice</div>
							<div className="notice-modal-subtitle">
								{this.state.migrasiLegacyStatus === 'pending'
									? 'Menunggu persetujuan Kantor Induk'
									: 'UPT ini belum pernah terdaftar di Gudang Notice'}
							</div>
						</div>
					</div>
					<div className="notice-modal-body">
						<ErrorAlertModal
							visible={this.state.errMsgMigrasiLegacy !== ''}
							title={this.state.errTitleMigrasiLegacy}
							error={this.state.errMsgMigrasiLegacy}
							onClose={() => this.setState({ errTitleMigrasiLegacy: '', errMsgMigrasiLegacy: '' })}
							zIndex={1010}
						/>

						{this.state.migrasiLegacyStatus === 'pending' ? (
							<>
								<div style={{
									background: '#fffbe6', border: '1px solid #ffe58f', borderRadius: 8,
									padding: '14px 16px', marginBottom: 20, fontSize: 13, color: '#874d00',
									display: 'flex', gap: 10, alignItems: 'flex-start',
								}}>
									<ClockCircleOutlined style={{ fontSize: 18, marginTop: 1 }} />
									<div>
										Pengajuan migrasi legacy UPT Anda sudah terkirim dan masih menunggu
										persetujuan Kantor Induk - box notice belum aktif, jadi nomor & kode
										notice belum bisa diatur. Hubungi Kantor Induk kalau pengajuan ini
										sudah lama tertunda.
									</div>
								</div>
								<div style={{ display: 'flex', gap: 10 }}>
									<Button
										onClick={() => this.clearCokies()}
										size="large"
										style={{ borderRadius: 8, fontWeight: 600, flex: 1 }}
									>
										Keluar
									</Button>
									<Button
										type="primary"
										icon={<SyncOutlined />}
										loading={this.state.loadingRefreshMigrasiLegacy}
										onClick={this.handleRefreshMigrasiLegacy}
										size="large"
										style={{
											borderRadius: 8, fontWeight: 600, flex: 1,
											background: 'linear-gradient(135deg, #1e4d8a, #0f2847)', border: 'none',
										}}
									>
										Cek Status
									</Button>
								</div>
							</>
						) : (
							<>
								<Alert
									type="warning"
									showIcon
									style={{ marginBottom: 16, borderRadius: 8 }}
									message="Wajib dicocokkan dengan opname fisik box"
									description="Sebelum bisa mencetak notice, UPT ini wajib didaftarkan dulu ke sistem Gudang Notice berdasarkan box fisik yang sedang dipegang - kode dan rentang nomor di bawah WAJIB sesuai fisik, bukan sekadar saran otomatis. Pengajuan ini akan diperiksa dan disetujui oleh Kantor Induk sebelum box aktif."
								/>
								{this.state.migrasiLegacySaran && (
									<div style={{
										background: '#f5f8fc', border: '1px solid #e3ecf7', borderRadius: 8,
										padding: '10px 14px', marginBottom: 16, fontSize: 12.5, color: '#374151',
									}}>
										Kode legacy saat ini: <b style={{ fontFamily: 'monospace' }}>{this.state.migrasiLegacySaran.kode_legacy}</b>,
										{' '}nomor terakhir transaksi: <b style={{ fontFamily: 'monospace' }}>{String(this.state.migrasiLegacySaran.nomor_legacy).padStart(7, '0')}</b>.
									</div>
								)}
								<Form layout="vertical">
									<Form.Item label="Kode Notice Baru (khusus UPT ini, jangan reuse kode legacy)" required>
										<Input
											size="large"
											placeholder="contoh: KSG1"
											maxLength={50}
											style={{ borderRadius: 8 }}
											value={this.state.migrasiKodeLegacy}
											onChange={(e) => this.setState({ migrasiKodeLegacy: e.target.value.toUpperCase() })}
										/>
									</Form.Item>
									<Row gutter={12}>
										<Col span={12}>
											<Form.Item label="Nomor Awal Box (sesuai fisik)" required>
												<InputNumber
													min={1}
													size="large"
													style={{ width: '100%', borderRadius: 8 }}
													value={this.state.migrasiAwalLegacy}
													onChange={(v) => this.setState({ migrasiAwalLegacy: v })}
												/>
											</Form.Item>
										</Col>
										<Col span={12}>
											<Form.Item label="Nomor Akhir Box (sesuai fisik)" required>
												<InputNumber
													min={1}
													size="large"
													style={{ width: '100%', borderRadius: 8 }}
													value={this.state.migrasiAkhirLegacy}
													onChange={(v) => this.setState({ migrasiAkhirLegacy: v })}
												/>
											</Form.Item>
										</Col>
									</Row>
								</Form>
								<Button
									type="primary"
									loading={this.state.loadingSubmitMigrasiLegacy}
									size="large"
									block
									icon={<SaveOutlined />}
									onClick={this.handleSubmitMigrasiLegacy}
									style={{
										borderRadius: 8, height: 46, fontWeight: 600, border: 'none',
										background: 'linear-gradient(135deg, #1e4d8a, #0f2847)',
									}}
								>
									Ajukan Migrasi
								</Button>
							</>
						)}
					</div>
				</Modal>

				<Modal
					visible={this.state.modalNotice}
					footer={null}
					closable={false}
					centered
					width="min(94vw, 840px)"
					bodyStyle={{ padding: 0 }}
					className="modal-notice"
				>
					{/* Header */}
					<div className="notice-modal-header">
						<div className="notice-modal-icon">
							<FileTextOutlined />
						</div>
						<div>
							<div className="notice-modal-title">Pengaturan Notice</div>
							<div className="notice-modal-subtitle">Atur nomor dan kode untuk pencetakan notice</div>
						</div>
					</div>

					{/* Body */}
					<div className="notice-modal-body">
						<ErrorAlertModal
							visible={this.state.errMsg !== ''}
							title={this.state.errTitle}
							error={this.state.errMsg}
							onClose={() => this.setState({ errTitle: '', errMsg: '' })}
							zIndex={1010}
						/>

						<Row gutter={24}>
						<Col xs={24} md={13}>
						{this._hasBoxAktif() && (
							<div style={{
								background: '#fffbe6', border: '1px solid #ffe58f', borderRadius: 8,
								padding: '10px 14px', marginBottom: 18, fontSize: 12.5, color: '#874d00',
							}}>
								Nomor &amp; kode dikunci karena UPT ini sedang punya box notice aktif - keduanya
								dikelola otomatis oleh sistem Gudang Notice (lihat panel di samping).
							</div>
						)}
						<Form
							layout="vertical"
							name="fdata"
							onFinish={this.handleSubmitNotice}
							ref={this.formRef}
						>
							<Form.Item
								label="Nomor Notice"
								name="nomor"
								rules={[{ required: true, message: 'Nomor harus diisi' }]}
							>
								<Input
									size="large"
									placeholder="Masukkan nomor notice"
									style={{ textTransform: 'none', borderRadius: 8 }}
									disabled={this._hasBoxAktif()}
								/>
							</Form.Item>

							<Form.Item
								label="Kode"
								name="kode"
								rules={[{ required: true, message: 'Kode harus diisi' }]}
								style={{ marginBottom: 24 }}
							>
								<Input
									size="large"
									placeholder="Masukkan kode"
									style={{ textTransform: 'none', borderRadius: 8 }}
									disabled={this._hasBoxAktif()}
								/>
							</Form.Item>

							<Button
								key="btn-simpan"
								loading={this.state.loadingButton}
								type="primary"
								htmlType="submit"
								disabled={!!this.state.errComponent}
								size="large"
								block
								icon={this._hasBoxAktif() ? <CloseCircleOutlined /> : <SaveOutlined />}
								style={{
									borderRadius: 8,
									height: 46,
									background: 'linear-gradient(135deg, #1e4d8a, #0f2847)',
									border: 'none',
									fontWeight: 600,
								}}
							>
								{this._hasBoxAktif() ? 'Tutup' : 'Simpan Pengaturan'}
							</Button>
						</Form>
						</Col>
						<Col xs={24} md={11} style={{ marginTop: this.props.isMobile ? 20 : 0 }}>
							<div style={{ background: '#fafafa', border: '1px solid #f0f0f0', borderRadius: 10, padding: 16, maxHeight: 360, overflowY: 'auto' }}>
								<BoxVisualList listBox={this.state.listBox} loading={this.state.loadingBoxList} />
							</div>
						</Col>
						</Row>
					</div>
				</Modal>

				{/* ===== DRAWER NOTIFIKASI BATAL NOTICE (Kasi Penetapan) ===== */}
			{this.props.akses && this.props.akses.transaksi_cancle_notice_approve && (() => {
				const { isCancelNoticeDrawer, cancelNoticePendingList, loadingCancelNotice } = this.state;
				const pendingCount = this.props.cancelNoticePendingCount || 0;
				return (
					<Drawer
						visible={isCancelNoticeDrawer}
						onClose={() => this.setState({ isCancelNoticeDrawer: false })}
						placement="right"
						width={380}
						bodyStyle={{ padding: 0, overflowY: 'auto' }}
						title={
							<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
								<span style={{ color: '#cf1322', fontSize: 16 }}>🔔</span>
								<span style={{ fontWeight: 700 }}>Permintaan Batal Notice</span>
								{pendingCount > 0 && (
									<span style={{
										background: '#ff4d4f', color: '#fff',
										borderRadius: 20, fontSize: 11, padding: '1px 8px', fontWeight: 600,
									}}>{pendingCount}</span>
								)}
							</div>
						}
						extra={
							<a href="/admin/transaksi/cancel-notice"
							   style={{ fontSize: 12, color: '#0f2847', fontWeight: 600 }}>
								Lihat Semua →
							</a>
						}
					>
						{loadingCancelNotice ? (
							<div style={{ textAlign: 'center', padding: 40 }}>
								<span>Memuat...</span>
							</div>
						) : cancelNoticePendingList.length === 0 ? (
							<div style={{ textAlign: 'center', padding: 40, color: '#888' }}>
								Tidak ada permintaan pending
							</div>
						) : (
							cancelNoticePendingList.map((item, i) => (
								<div key={item.id} style={{
									padding: '14px 18px',
									borderBottom: i < cancelNoticePendingList.length - 1 ? '1px solid #f5f5f5' : 'none',
								}}>
									<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
										<span style={{ fontWeight: 700, color: '#0f2847', fontSize: 14 }}>
											{item.nomor_polisi}
										</span>
										<span style={{
											fontSize: 10, background: '#fffbe6', color: '#d46b08',
											border: '1px solid #ffe58f', borderRadius: 20, padding: '1px 8px',
										}}>
											{item.jenis === 'rusak' ? 'Notice Rusak' : 'Batal Validasi'}
										</span>
									</div>
									<div style={{ fontSize: 12, color: '#666', marginBottom: 2 }}>
										Kasir: <b>{item.diajukan_oleh_nama}</b>
										{item.upt_nama && (
											<span style={{ color: '#aaa', marginLeft: 4 }}>({item.upt_nama})</span>
										)}
									</div>
									{item.keterangan && (
										<div style={{ fontSize: 11, color: '#999', marginBottom: 6 }}>
											"{item.keterangan}"
										</div>
									)}
									<div style={{ display: 'flex', gap: 6, marginTop: 6 }}>
										<a href="/admin/transaksi/cancel-notice"
										   style={{ fontSize: 12, color: '#0f2847', fontWeight: 600 }}>
											Tinjau →
										</a>
									</div>
								</div>
							))
						)}
					</Drawer>
				);
			})()}

			{/* ===== DRAWER PAPAN PENGUMUMAN (global) ===== */}
				{(() => {
					const { pengumuman, loadingPengumuman, loadingTogglePengumuman, submitPengumuman } = this.state;
					const lv = this.props.level_user || 3;
					return (
						<Drawer
							visible={this.state.isPengumumanDrawer}
							onClose={() => this.setState({ isPengumumanDrawer: false })}
							placement="right"
							width={400}
							bodyStyle={{ padding: 0, overflowY: 'auto' }}
							title={
								<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
									<NotificationOutlined style={{ color: '#1890ff' }} />
									<span>Papan Pengumuman</span>
									<span style={{ background: '#1890ff', color: '#fff', borderRadius: 20, fontSize: 11, padding: '1px 8px', fontWeight: 600 }}>
										{pengumuman.length}
									</span>
								</div>
							}
							extra={lv <= 2 && (
								<Button size="small" type="primary" icon={<PlusOutlined />}
									onClick={() => this.setState({ isModalPengumuman: true })}>
									Tambah
								</Button>
							)}
						>
							<Spin spinning={loadingPengumuman}>
								{pengumuman.length === 0
									? <Empty description="Belum ada pengumuman" style={{ padding: '32px 0' }} />
									: pengumuman.map((p, i) => {
										const cfg = TIPE_CONFIG[p.tipe] || TIPE_CONFIG.umum;
										const tgl = p.created_at
											? new Date(p.created_at).toLocaleDateString('id-ID', { day: '2-digit', month: 'long', year: 'numeric' })
											: '-';
										const isNonaktif = !p.is_aktif;
										return (
											<div key={p.id} style={{
												display: 'flex', borderBottom: i < pengumuman.length - 1 ? '1px solid #f5f5f5' : 'none',
												opacity: isNonaktif ? 0.55 : 1, background: isNonaktif ? '#fafafa' : 'transparent',
											}}>
												<div style={{ width: 4, background: isNonaktif ? '#d1d5db' : cfg.color, flexShrink: 0 }} />
												<div style={{ padding: '12px 14px', flex: 1 }}>
													<div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', marginBottom: 6 }}>
														<Tag icon={cfg.icon} style={{ color: cfg.color, background: cfg.bg, border: `1px solid ${cfg.border}`, borderRadius: 20, fontWeight: 600, fontSize: 10, padding: '0 8px', margin: 0 }}>
															{cfg.label}
														</Tag>
														{p.versi && <Tag style={{ borderRadius: 20, fontSize: 10, fontWeight: 600, margin: 0 }}>v{p.versi}</Tag>}
														{isNonaktif && <Tag style={{ borderRadius: 20, fontSize: 10, fontWeight: 600, margin: 0, background: '#fee2e2', color: '#dc2626', border: '1px solid #fecaca' }}>Nonaktif</Tag>}
														<Typography.Text strong style={{ fontSize: 13, flex: 1, textTransform: 'none' }}>{p.judul}</Typography.Text>
														{lv <= 2 && (
															<div style={{ display: 'flex', gap: 4, flexShrink: 0 }}>
																<Tooltip title="Edit">
																	<Button size="small" type="text" icon={<EditOutlined />}
																		style={{ color: '#6366f1', padding: '0 4px' }}
																		onClick={() => this.setState({ editPengumuman: { ...p }, isEditModalPengumuman: true })} />
																</Tooltip>
																<Tooltip title={isNonaktif ? 'Aktifkan' : 'Nonaktifkan'}>
																	<Button size="small" type="text"
																		icon={isNonaktif ? <EyeOutlined /> : <EyeInvisibleOutlined />}
																		loading={loadingTogglePengumuman === p.id}
																		style={{ color: isNonaktif ? '#16a34a' : '#f59e0b', padding: '0 4px' }}
																		onClick={() => this.togglePengumuman(p)} />
																</Tooltip>
															</div>
														)}
													</div>
													<div style={{ color: '#666', fontSize: 12, lineHeight: 1.6, whiteSpace: 'pre-wrap', background: '#f8f9fc', borderRadius: 6, padding: '7px 10px', marginBottom: 6, textTransform: 'none' }}>
														{p.isi}
													</div>
													<div style={{ display: 'flex', gap: 12, color: '#bbb', fontSize: 11 }}>
														<span><UserOutlined /> {p.created_by_nama}</span>
														<span><CalendarOutlined /> {tgl}</span>
													</div>
												</div>
											</div>
										);
									})
								}
							</Spin>
						</Drawer>
					);
				})()}

				{/* ===== DRAWER USER AKTIF (global, hanya level <= 2) ===== */}
				{(this.props.level_user || 3) <= 2 && (() => {
					const { isUserAktifDrawer, activeUsers, activeUsersCount, loadingActiveUsers } = this.state;
					return (
						<Drawer
							visible={isUserAktifDrawer}
							onClose={() => this.setState({ isUserAktifDrawer: false })}
							placement="right"
							width={370}
							bodyStyle={{ padding: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}
							title={
								<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
									<TeamOutlined style={{ color: '#52c41a' }} />
									<span>User Sedang Login</span>
									<span style={{ background: '#52c41a', color: '#fff', borderRadius: 20, fontSize: 11, padding: '1px 8px', fontWeight: 600 }}>
										{activeUsersCount}
									</span>
								</div>
							}
							extra={
								<Tooltip title="Refresh">
									<Button size="small" icon={<SyncOutlined spin={loadingActiveUsers} />} onClick={() => this.loadActiveUsers()} />
								</Tooltip>
							}
						>
							<div style={{ overflowY: 'auto', flex: 1 }}>
								<Spin spinning={loadingActiveUsers}>
									{activeUsers.length === 0
										? <Empty description="Tidak ada user yang sedang login" style={{ padding: '32px 0' }} />
										: activeUsers.map((u, i) => {
											const ttlPct = Math.min(100, Math.round((u.ttl / 120) * 100));
											const dotColor = u.ttl > 90 ? '#52c41a' : u.ttl > 45 ? '#fa8c16' : '#ff4d4f';
											return (
												<div key={u.user_id} style={{ display: 'flex', alignItems: 'center', padding: '10px 14px', borderBottom: i < activeUsers.length - 1 ? '1px solid #f5f5f5' : 'none', gap: 10 }}>
													<div style={{ width: 36, height: 36, borderRadius: '50%', background: u.superuser ? 'linear-gradient(135deg,#722ed1,#eb2f96)' : 'linear-gradient(135deg,#1890ff,#13c2c2)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, color: '#fff', fontWeight: 700, fontSize: 14 }}>
														{(u.nama || u.username).charAt(0).toUpperCase()}
													</div>
													<div style={{ flex: 1, minWidth: 0 }}>
														<div style={{ fontWeight: 600, fontSize: 13, color: '#222', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
															{u.nama}{u.superuser && <span style={{ marginLeft: 5, fontSize: 10, color: '#722ed1', fontWeight: 400 }}>superuser</span>}
														</div>
														<div style={{ fontSize: 11, color: '#888', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{u.jabatan} · {u.upt}</div>
													</div>
													<Tooltip title={`Sesi aktif ${u.ttl}s`}>
														<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flexShrink: 0, gap: 3 }}>
															<div style={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: dotColor, boxShadow: `0 0 4px ${dotColor}` }} />
															<div style={{ width: 28, height: 3, borderRadius: 2, background: '#f0f0f0', overflow: 'hidden' }}>
																<div style={{ height: '100%', width: `${ttlPct}%`, background: dotColor, transition: 'width 1s linear' }} />
															</div>
														</div>
													</Tooltip>
												</div>
											);
										})
									}
								</Spin>
							</div>
							<div style={{ padding: '8px 14px', borderTop: '1px solid #f0f0f0', fontSize: 11, color: '#bbb', textAlign: 'right', flexShrink: 0 }}>
								Live Online Users
							</div>
						</Drawer>
					);
				})()}

				{/* Modal Tambah Pengumuman */}
				<Modal
					title={<span><NotificationOutlined style={{ color: '#fa8c16' }} /> Tambah Pengumuman</span>}
					visible={this.state.isModalPengumuman}
					onCancel={() => this.setState({ isModalPengumuman: false, formPengumuman: { judul: '', isi: '', tipe: 'umum', versi: '' } })}
					onOk={() => this.submitFormPengumuman()}
					okText="Simpan" cancelText="Batal"
					confirmLoading={this.state.submitPengumuman}
					width={560}
				>
					<Form layout="vertical" style={{ marginTop: 8 }} className="no-uppercase">
						<Row gutter={12}>
							<Col span={16}>
								<Form.Item label="Judul" required>
									<Input placeholder="Judul pengumuman" style={{ textTransform: 'none' }}
										value={this.state.formPengumuman.judul}
										onChange={e => this.setState({ formPengumuman: { ...this.state.formPengumuman, judul: e.target.value } })} />
								</Form.Item>
							</Col>
							<Col span={8}>
								<Form.Item label="Versi (opsional)">
									<Input placeholder="contoh: 1.2.3" style={{ textTransform: 'none' }}
										value={this.state.formPengumuman.versi}
										onChange={e => this.setState({ formPengumuman: { ...this.state.formPengumuman, versi: e.target.value } })} />
								</Form.Item>
							</Col>
						</Row>
						<Form.Item label="Kategori" required>
							<Select value={this.state.formPengumuman.tipe}
								onChange={v => this.setState({ formPengumuman: { ...this.state.formPengumuman, tipe: v } })}>
								<Select.Option value="backend"><CodeOutlined /> Backend</Select.Option>
								<Select.Option value="frontend"><DesktopOutlined /> Frontend</Select.Option>
								<Select.Option value="umum"><InfoCircleOutlined /> Umum</Select.Option>
							</Select>
						</Form.Item>
						<Form.Item label="Isi Pengumuman" required>
							<Input.TextArea rows={5} placeholder="Tulis detail di sini..." style={{ textTransform: 'none' }}
								value={this.state.formPengumuman.isi}
								onChange={e => this.setState({ formPengumuman: { ...this.state.formPengumuman, isi: e.target.value } })} />
						</Form.Item>
					</Form>
				</Modal>

				{/* Modal Edit Pengumuman */}
				<Modal
					title={<span><EditOutlined style={{ color: '#6366f1' }} /> Edit Pengumuman</span>}
					visible={this.state.isEditModalPengumuman}
					onCancel={() => this.setState({ isEditModalPengumuman: false, editPengumuman: null })}
					onOk={() => this.updatePengumuman()}
					okText="Simpan Perubahan" cancelText="Batal"
					confirmLoading={this.state.submitPengumuman}
					width={560}
				>
					{this.state.editPengumuman && (
						<Form layout="vertical" style={{ marginTop: 8 }} className="no-uppercase">
							<Row gutter={12}>
								<Col span={16}>
									<Form.Item label="Judul" required>
										<Input placeholder="Judul pengumuman" style={{ textTransform: 'none' }}
											value={this.state.editPengumuman.judul}
											onChange={e => this.setState({ editPengumuman: { ...this.state.editPengumuman, judul: e.target.value } })} />
									</Form.Item>
								</Col>
								<Col span={8}>
									<Form.Item label="Versi (opsional)">
										<Input placeholder="contoh: 1.2.3" style={{ textTransform: 'none' }}
											value={this.state.editPengumuman.versi || ''}
											onChange={e => this.setState({ editPengumuman: { ...this.state.editPengumuman, versi: e.target.value } })} />
									</Form.Item>
								</Col>
							</Row>
							<Form.Item label="Kategori" required>
								<Select value={this.state.editPengumuman.tipe}
									onChange={v => this.setState({ editPengumuman: { ...this.state.editPengumuman, tipe: v } })}>
									<Select.Option value="backend"><CodeOutlined /> Backend</Select.Option>
									<Select.Option value="frontend"><DesktopOutlined /> Frontend</Select.Option>
									<Select.Option value="umum"><InfoCircleOutlined /> Umum</Select.Option>
								</Select>
							</Form.Item>
							<Form.Item label="Isi Pengumuman" required>
								<Input.TextArea rows={5} style={{ textTransform: 'none' }}
									value={this.state.editPengumuman.isi}
									onChange={e => this.setState({ editPengumuman: { ...this.state.editPengumuman, isi: e.target.value } })} />
							</Form.Item>
							<Form.Item label="Status">
								<Select value={this.state.editPengumuman.is_aktif}
									onChange={v => this.setState({ editPengumuman: { ...this.state.editPengumuman, is_aktif: v } })}>
									<Select.Option value={true}><EyeOutlined style={{ color: '#16a34a' }} /> Aktif</Select.Option>
									<Select.Option value={false}><EyeInvisibleOutlined style={{ color: '#dc2626' }} /> Nonaktif</Select.Option>
								</Select>
							</Form.Item>
						</Form>
					)}
				</Modal>
			</Layout>
			{this.props.isMobile && <MobileBottomNav />}
			</>
		);
	}
}

const mapStateToProps = function (state) {
	return state.configReducers
}

export default connect(mapStateToProps, {
	setConfig,
	ajaxViewHandler,
	ajaxHandler
})(withRouter(AdminLayout));
